import type { TranslationKey } from './en.js';

import { interfaceHu } from './interface.js';
import { duesAttendanceHu } from './dues-attendance.js';

export const hu = {
  ...interfaceHu,
  ...duesAttendanceHu,
  'app.name': 'Sportcsapat-kezelés',
  'app.tagline': 'A klub működése egyetlen biztonságos helyen',
  'locale.label': 'Nyelv',
  'locale.en': 'Angol',
  'locale.hu': 'Magyar',
  'locale.ro': 'Román',
  'nav.overview': 'Áttekintés',
  'nav.athletes': 'Sportolók',
  'nav.teams': 'Csapatok',
  'nav.calendar': 'Naptár',
  'nav.training': 'Edzések',
  'nav.assessments': 'Felmérések',
  'nav.billing': 'Pénzügyek',
  'nav.payments': 'Befizetések',
  'nav.competitions': 'Versenyek',
  'nav.reports': 'Jelentések',
  'nav.settings': 'Beállítások',
  'page.login': 'Bejelentkezés',
  'page.invite': 'Meghívó elfogadása',
  'page.notFound': 'Az oldal nem található',
  'help.login':
    'A folytatáshoz válassza a Bejelentkezés lehetőséget a klubfiókjával; utána ide tér vissza. A munkamenet munkatársi fiókoknál 30 perc, családi fiókoknál 12 óra tétlenség után lejár, és legfeljebb hét napig tart. Ha a bejelentkezés nem sikerül, próbálja újra, vagy forduljon a klub titkárához. Amíg a szerepköre nincs beállítva, klubadatok nem jelennek meg.',
  'help.invite':
    'Nyissa meg a klubtól (például e-mailben) kapott meghívó linkjét, vagy illessze be ide a meghívókódot, és jelentkezzen be az elfogadáshoz. A meghívó 72 óráig érvényes, egyszer használható, és csak a benne megnevezett szerepköröket, személyeket és fiókokat adja. Az e-mail-címe önmagában sosem ad hozzáférést egy gyermek adataihoz. Van már fiókja, például egy korábbi meghívóból vagy egy másik klubból? Válassza a Jelentkezzen be az elfogadáshoz gombot. Még nincs fiókja? Válassza a Fiók létrehozása gombot. Ha a bejelentkezési oldal szerint az e-mail-címe már foglalt, akkor már van fiókja: jelentkezzen be, szükség esetén az elfelejtett jelszó hivatkozással. Bejelentkezés vagy regisztráció után a kitöltött meghívóhoz tér vissza; válassza a Meghívó elfogadása gombot. Ha gyermek nélkül hívták meg szülőként, eleinte nem lát gyermeket: nyissa meg a Gyermekeim oldalt, használja a Gyermek hozzáadása részt, és a gyermek a klub jóváhagyása után megjelenik.',
  'help.notFound':
    'Ez az oldal nem létezik, vagy nincs hozzáférésed hozzá. A menüből visszatérhetsz egy megnyitható területre.',
  'help.overview':
    'Az áttekintés összefoglalja, mire érdemes figyelned. Csak azokat a területeket mutatja, amelyeket használhatsz. A klubadminisztrátorok és titkárok azt is látják, mire kell odafigyelni: gondviselői kapcsolat nélküli kiskorúak, döntésre váró gondviselői kapcsolatok és importálások, az elmúlt 30 nap új belépői, valamint érvényes klubtagság nélküli aktív sportolók, mindegyik darabszámmal és az első néhány névvel.',
  'help.athletes':
    'A sportolók ábécésorrendben, táblázatban szerepelnek; a keresőmezővel név alapján megtalálhatsz valakit. Minden sor végén műveleti ikonok vannak: a szem megnyitja a sportoló részleteit (klubtagsági időszakok, hokiprofil, szülőnek a változtatási kérések), a klubadminisztrátorok és a titkárok pedig a ceruzával javíthatják az adatokat, a dobozzal archiválhatják, kiléptethetik vagy újraaktiválhatják a sportolót. A pénzügyesek az érme ikont és a részletekben a Befizetés rögzítése gombot is látják: ez megnyitja azt a számlázási fiókot, amelyhez a sportoló tartozik (ha több van, válassz), és ott rögzít egy befizetést, például a sportoló által hozott készpénzt, ugyanazzal az előnézettel és a legrégebbi nyitott tételekre történő elszámolással, mint a pénzügyi oldalon; a számlázási fiókhoz nem rendelt sportolót előbb ott kell egy fiókhoz rendelni. Telefonon a születési dátum, az e-mail és a telefon oszlop rejtve van; ezeket a részletekben látod. Az oldal tetején lévő Sportoló felvétele gomb megnyitja az új adatlap űrlapját. Csak azokat a sportolókat látod, amelyeket a szerepköröd lefed: a szülő a saját, hozzákapcsolt gyermekeit, az edző a szakosztálya sportolóit, a klubadminisztrátorok és a titkárok az egész klubot. Sportolót csak a klubadminisztrátorok és a titkárok vehetnek fel vagy javíthatnak, és csak ők látják az e-mail-címet és a telefonszámot. Ha már létezik azonos nevű és születési dátumú sportoló, figyelmeztetést kapsz, és meg kell erősítened a második adatlap létrehozását; az adatlapokat a rendszer soha nem vonja össze automatikusan. Ha szerkesztés közben valaki más módosította az adatlapot, töltsd újra az oldalt, és próbáld meg újra. A titkárok itt egy Szülői kapcsolatok szakaszt is látnak: kérhetnek kapcsolatot egy szülő és egy sportoló között (választhatnak a klubban már szereplő szülők közül, vagy megadhatnak egy újat, megadva a kapcsolat típusát és azt, hogy a szülő mit tehet), majd jóváhagyhatják, elutasíthatják vagy visszavonhatják. A kapcsolat jóváhagyásig semmilyen hozzáférést nem ad, az olyan kapcsolatot, amelyben te vagy a szülő, nem hagyhatod jóvá, a kapcsolat visszavonása pedig azonnal elveszi a gyermeket attól a szülőtől. A csapatokat és az edzéscsoportokat a Csapatok oldalon kezelheted. A sportoló részleteiben a szerepkörödtől függően látod a klubtagsági időszakokat; a klubadminisztrátorok és a titkárok elindíthatnak egy tagságot (a kezdő dátum alapértelmezetten a mai nap) vagy befejezhetnek egy nyitottat, a befejezett tagság előzményként megmarad. Egy sportoló tagságai nem fedhetik át egymást, és a tagság független a csapat- és edzéscsoport-beosztásoktól: a befejezése nem veszi le a sportolót a csapatról. Amikor egy sportoló betölti a 18. életévét, a szülő hozzáférése automatikusan szünetel; a 18 éves korba lépő sportolók listája megmutatja, kik következnek, meghívhatja őket saját fiókba, és az egyes kapcsolatokat megújíthatja, amint a sportoló engedélyezte. Egy jóváhagyott kapcsolatnál azt is módosíthatja, hogy a szülő mit tehet, illetve a befejező dátumot. A klubadminisztrátorok és a titkárok indoklással archiválhatnak egy sportolót vagy rögzíthetik a kilépését: ez ma lezárja a nyitott klubtagságot, valamint a csapat- és csoportbeosztásokat, a kilépés pedig a szülők hozzáférését is megszünteti ma után; minden előzményként megmarad, az újraaktiválás pedig semmit nem állít vissza. A klubadminisztrátorok és titkárok importálási szakaszt is látnak: töltsön le CSV sablont (sportolók, gondviselői kapcsolatok vagy tagságok), töltse ki UTF-8 kódolással, adja meg a forrásrendszer nevét és a fájl dátumrendszerét, majd ellenőriztesse a fájlt. Minden sor ellenőrzésre kerül, és kész, hibás, döntésre váró vagy már importált állapotot kap; a képletet tartalmazó, táblázat formátumú vagy 1000 sornál hosszabb fájlt elutasítjuk. Az a sor, amely név és születési dátum alapján egyezik egy meglévő sportolóval, kifejezett döntést igényel (új sportoló létrehozása, a meglévőhöz kapcsolás vagy kihagyás); a rekordokat soha nem vonjuk össze automatikusan. Semmi nem kerül mentésre, amíg nem importálja a kész sorokat, és csak akkor, ha egy sor sem hibás vagy vár döntésre. Az importálás egyszerre történik; ha közben a klub adatai megváltoztak, semmi nem importálódik, és újra ellenőriztetheti a fájlt. Ugyanannak a fájlnak az ismételt importálása nem hoz létre duplikátumokat, mert a sorokat forrás és külső azonosító alapján ismerjük fel. A gondviselői sorok csak hozzáférés nélküli, függő kapcsolatokat hoznak létre, és senki nem kap meghívót vagy értesítést. Minden sportolónál megjelenik egy Jégkorong-profil is a preferált posztokkal (kapus, védő, csatár) és az ütőfogással; mindenki olvashatja, aki látja a sportolót, a klubadminisztrátorok és titkárok módosíthatják. A mérkőzésen játszott posztot a mérkőzés-keret rögzíti, nem ez a profil. A gondviselő minden kapcsolt gyermek részleteiben kérhet módosítást: új e-mail-címet vagy telefonszámot, illetve a név vagy a születési dátum javítását. Semmi nem változik, amíg a titkár jóvá nem hagyja; a titkár egymás mellett látja a jelenlegi és a javasolt értékeket, elutasításhoz indoklást kell adnia, és a saját kérelmét nem bírálhatja el. A név és a születési dátum javítását igazolás alapján érdemes ellenőrizni. A még várakozó kérelem visszavonható. A gondviselő a kapcsolt gyermek klubtagsági időszakait is látja, ha a kapcsolat engedélyezi a tagság megtekintését. A szülők általában meghívóval csatlakoznak: a klubadminisztrátorok és a titkárok a Szülő meghívása résznél megadják a szülő e-mail-címét és nevét; ha a klubnak van feladócíme, az alkalmazás e-mailben elküldi a meghívót, különben a megjelenő linket kell továbbítani; a szülő bejelentkezik, és a Gyermek hozzáadása résznél megadja minden gyermeke nevét, születési dátumát és a rokoni kapcsolatot. A kérelem önmagában semmilyen hozzáférést nem ad. A titkárok a Szülők által kért gyermekek résznél látják, az aznap született, azonos nevű sportolókkal együtt; kiválasztják a megfelelő sportolót vagy új adatlapot hoznak létre, megtartják vagy elveszik a jogosultságokat, és jóváhagyják, ami azonnal jóváhagyott szülői kapcsolatot nyit, vagy indoklással elutasítják, amelyet a szülő is lát. A szülő a még elbírálásra váró kérelmet visszavonhatja. Ha Ön maga kapcsol egy szülőt több meglévő sportolóhoz, a szülői kapcsolat űrlapján adja hozzá egymás után a sportolókat, és ha már ellenőrizte a kapcsolatot, jelölje be a kapcsolatok azonnali jóváhagyását. Ha egy kapcsolat szülőjének még nincs fiókja, a Meghívás az alkalmazásba gombbal meghívhatja. A szülői kapcsolatok és a gyermekkérelmek jóváhagyása titkári feladat; a klubadminisztrátor a Beállításokban a saját fiókjához adhatja a Titkár szerepkört.',
  'help.teams':
    'Válassz egy szezont, hogy lásd a csapatait és edzéscsoportjait, a Tagok mutatása gombbal pedig megnézheted, kik tartoznak egy kerethez. Csak azokat a szakosztályokat látod, amelyeket a szerepköröd lefed. A klubadminisztrátorok és a titkárok felvehetnek szezont (tervezetként indul; aktiváld, amikor elkezdődik, és zárd le, amikor véget ér), csapatokat és edzéscsoportokat adhatnak egy le nem zárt szezonhoz, valamint sportolókat oszthatnak be, vagy lezárhatják a beosztásukat. A beosztáshoz kezdő dátum kell (alapértelmezés: ma); a beosztás lezárása megőrzi az előzményt, a jövőbeli befejező dátum pedig addig a napig a kereten tartja a sportolót. Egy sportoló ugyanabban a csapatban vagy csoportban nem szerepelhet kétszer egymást átfedő időszakra, és egy mezszámot egy csapatban egyszerre csak egy tag használhat. A korosztályok csak címkék: nem döntik el, ki indulhat egy versenyen. Ha szerkesztés közben valaki más módosított egy szezont vagy beosztást, töltsd újra az oldalt, és próbáld meg újra. A következő szezon előkészítéséhez használd A következő szezon megtervezése gombot: válaszd ki, mely csapatokat és edzéscsoportokat tartod meg (átnevezheted őket, vagy módosíthatod a korosztályukat), add meg a dátumokat, és szükség esetén oszd be az új csapatokba a ma aktív sportolókat. Ez csak egy új, tervezet állapotú szezont ad hozzá; a régi szezon, a csapatai és a keretei soha nem változnak.',
  'help.calendar':
    'A naptár a kiválasztott időszak eseményeit mutatja napok szerint. A munkatársak a szerepük által lefedett szakosztályok eseményeit látják; a családok csak a hozzájuk kapcsolt gyermekek közzétett eseményeit, az időponttal, a helyszínnel és a válaszadási határidővel. A klubadminisztrátorok, a titkárok és az edzők eseményt vehetnek fel (először tervezetként), meghívhatnak teljes csapatokat vagy edzéscsoportokat, vagy a Játékosok kiválasztása gombbal megnyithatnak egy névsort, és csak a szükséges játékosokat jelölhetik be, akár több csapatból is (bárki más név szerint is hozzáadható), kiválaszthatnak jégpályát, pályarészt vagy termet, és a kiválasztott napokon minden héten vagy két-, három- vagy négyhetente ismétlődővé tehetik; az ismétlődő esemény a nyári és téli időszámítás váltásakor is megtartja a helyi kezdési időt. A közzététel egyszer adja hozzá a meghívott sportolókat akkor is, ha több csapatba vagy csoportba tartoznak, és értesíti a családjukat; a lemondás megtartja az eseményt az indokkal együtt, a még el nem kezdődött lemondott esemény pedig az Esemény visszaállítása gombbal visszaállítható. Egy sorozat bármelyik alkalmát megnyitva látja a következő alkalmakat: vegye ki a pipát egy alkalomnál, ha csak azt akarja lemondani (például a holnapi edzést), és jelölje be újra, ha visszaállítaná. Az Időrend módosítása a választott naptól új napokat, ismétlési gyakoriságot, időpontot vagy záró dátumot állít be: a megmaradó napok alkalmai megtartják a válaszokat és a jelenlétet, és az új időpontra kerülnek, a kimaradó napok alkalmai az Ön által megadott indokkal elmaradnak, az új napokra új alkalmak készülnek, a korábbi alkalmak pedig nem változnak. Lemondáskor és visszaállításkor eldöntheti, értesüljenek-e a meghívott családok; az értesítések most sorba kerülnek, és az értesítések bekapcsolása után mennek ki. Ha egy közzétett esemény meghívottjait módosítja (Szerkesztés), a résztvevők azonnal frissülnek; aki már válaszolt vagy akinek rögzítették a jelenlétét, a helyén marad. Két esemény nem használhatja ugyanazt az erőforrást egyszerre (a teljes pálya foglalása a részeit is blokkolja, és a takarítási idő is számít); a máshol már lefoglalt edzőt a rendszer elutasítja, a már másik eseményre várt sportolókhoz pedig megerősítés kell. A családok a határidőig válaszolhatnak igennel, nemmel vagy talánnal (alapértelmezés szerint a kezdés előtt két órával, ha az esemény mást nem ír elő); az edző később indokkal javíthatja a választ. Nyisson meg egy eseményt, hogy lássa, ki válaszolt, az edzők pedig sportolónként egy érintéssel rögzíthetik a jelenlétet: ha másik edző előbb mentett egy sort, az ő bejegyzését látja, és semmi sem íródik felül. Ha a tagságok a közzététel után változnak, először ellenőrizze a tagsági változásokat; aki válaszolt vagy akinek rögzítették a jelenlétét, azt a rendszer soha nem távolítja el. A jégpályák, pályarészek és termek a Helyszínek és erőforrások részben állíthatók be. A jelenléti arány a jelen és késett összege osztva a jelen, késett és mindkét fajta hiányzás összegével; a lemondott események és a nem rögzített sorok nem számítanak.',
  'help.training':
    'A gyakorlatokat és az edzésterveket itt készítik elő az edzők, szakosztályonként. A gyakorlatnak egy vagy több nyelven van megnevezése, időtartama, eszközlistája és edzői útmutatója, amelyet csak a munkatársak látnak; a módosítás mentése új változatot hoz létre, és soha nem változtatja meg a régebbi változatot már használó terveket. Az edzésterv blokkok listája, mindegyiknek van célja, időtartama, opcionális gyakorlata, intenzitása, eszközei, felülete és privát edzői jegyzete; egy blokknak lehetnek párhuzamos állomásai, ilyenkor a leghosszabb állomás idejéig tart, nem az összegéig. A tervezett aktív időnek bele kell férnie az alkalomba az előkészítés és a szünetek után, különben indokot kell megadni. Az edzésterv tervezetként indul; a közzététel befagyasztja a változatot, módosításhoz új változatot kell indítani, így a már használó alkalom pontosan azt őrzi, amit használt. Válassza ki, mely blokkokhoz kerüljön rövid összefoglaló a családoknak: a tervezeteket, a célokat és az edzői jegyzeteket soha nem látják. A közzétett tervváltozatot a Naptár oldalon rendelheti egy eseményhez.',
  'help.assessments':
    'Itt az edzők felmérési protokollokat határoznak meg. A protokoll megadja az eredmény típusát (szám, időtartam, igen vagy nem, vagy szintekből álló értékelési skála), a mértékegységet, a megőrzött tizedesjegyek számát, a legalacsonyabb és legmagasabb érvényes értéket, hogy az alacsonyabb vagy a magasabb a jobb, hány kísérlet engedélyezett, és hogyan számít az eredmény: a legjobb kísérlet, az átlag, az utolsó érvényes kísérlet, vagy egy olyan kísérlet, amelyet az edző indoklással kiválaszt. A módosítás mentése új változatot hoz létre, és soha nem változtatja meg a korábbi változatot használó alkalmakat; a távolságot, a pályát, a felületet és a módszert minden eredmény megőrzi, és bármelyik megváltoztatása új sorozatot indít a fejlődési grafikonokon. Az eredmények rögzítéséhez hozzon létre egy alkalmat egy szakosztályhoz, válassza ki a protokollokat és a résztvevőket, majd írja be az egyes kísérleteket: hagyja üresen a meg nem tett kísérletet, nullát csak mért nulla esetén írjon, az elrontott kísérletet pedig jelölje érvénytelennek. A lehetetlen értékeket, például a negatív időtartamot, a túl sok tizedesjegyet, a határokon kívüli értéket vagy más mértékegységet a rendszer indoklással elutasítja. Az eredmények piszkozatok maradnak, amelyeket csak a szakosztály edzői látnak a privát megjegyzésekkel együtt, amíg közzé nem teszi őket; a közzététel megmutatja a számító eredményt és a családnak szánt megjegyzést azoknak a szülőknek, akiknek a kapcsolata ezt engedi, valamint a sportolónak. Ha egy másik edző előbb módosított egy sort, az ő bejegyzését látja, és semmi sem íródik felül. A közzétett eredményt csak indoklással ellátott javítás változtathatja meg: a családok a javítás közzétételéig a közzétett eredményt látják, a korábbi változat pedig megmarad a nyilvántartásban; a még közzé nem tett javítás elvethető, ilyenkor a közzétett eredmény változatlan marad. Az Eredmények exportálása a foglalkozás közzétett eredményeit tölti le CSV-fájlként az Ön nyelvén, piszkozatok, kísérletek és privát jegyzetek nélkül; minden letöltést az auditnapló rögzít. A csoportösszesítők csak a stábnak szólnak, öt résztvevőnél kevesebb esetén nem jelennek meg, és nincsenek ranglisták. A Fejlődés részben válasszon sportolót, hogy lássa a közzétett eredményeket időrendben, minden összehasonlítható protokollhoz egy grafikonnal és táblázattal; a vonal megszakadása azt jelenti, hogy nem rögzítettek érvényes értéket, és ezt soha nem olvassuk nullának. A megjelenített változás a mérési adatokról szóló számítás, nem a gyermek értékének vagy képességeinek megítélése. Foglalkozás létrehozásakor egy részleg teljes csapatát vagy edzéscsoportját egyszerre hozzáadhatja, majd név szerint finomíthatja a kijelölést.',
  'help.billing':
    'A pénzügyi felelős itt kezeli a számlázási fiókokat. A Számlázási fiókok rész az oldallal együtt nyílik meg, és összecsukható; soronként egy fiókot mutat az egyenlegével, a lejárt összeggel, a közelgő tételekkel és a fel nem osztott jóváírással (telefonon csak az egyenleggel), a Fiók megnyitása gomb pedig megnyitja. A fiókon belül az éves tagdíj és a havi díjtervek külön részben szerepelnek: annak a klubnak, amely csak éves díjat szed, nincs szüksége havi díjtervre. Az új díjterv a klub pénznemében indul, amelyet a Beállítások oldal Klubadatok részében lehet megadni. Minden fiók saját egyenleget vezet; a különböző fiókok egyenlegét sosem adjuk össze. Könyveljen tételt esedékességgel, vagy könyveljen befizetést: nézze meg a legrégebbi esedékesség szerinti képzést, szükség esetén módosítsa az összegeket, majd erősítse meg. Ami nincs képezve, az le nem képzett jóváírásként marad. A könyvelt tételeket nem szerkesztjük: javításhoz sztornózza őket, vagy indoklással könyveljen jóváíró számlát vagy visszatérítést. A kapcsolat megszakadása utáni újrapróbálás sosem könyvel kétszer. A díjcsomag havi összeget, esedékességi napot és hatályossági időszakot határoz meg; a díjcsomag-verziót sosem szerkesztjük, a módosítás új verzióként mentődik. A fiókon rendeljen díjcsomagot a sportolóhoz kezdő dátummal, szükség esetén jóváhagyott kedvezménnyel (fix összeg vagy százalék, mindig indoklással), és szüneteltesse vagy zárja le, ha kell; a sportolónak egy fiókon egyszerre egy díja van, ezért a csomagváltás egy lezárás és egy új hozzárendelés. A havi díjfuttatáshoz válasszon hónapot, nézze meg az előnézetet, majd könyvelje. A futtatás hozzárendelésenként és hónaponként egy tételt könyvel az esedékességi napra (a hónap végén túli nap a hónap utolsó napjára esik); a hónap közben kezdődő hozzárendelés megvárja, hogy Ön megadja az első tételt; a szüneteltetett vagy lezárt hozzárendeléseket kihagyja; a már kiszámlázott hónapot pedig sosem számlázza ki újra, akkor sem, ha kétszer könyveli a futtatást. Az Automatikus havi futtatás résznél a pénzügyi felelős bekapcsolhatja az automatikus könyvelést. Bekapcsolásig ki van kapcsolva; bekapcsolás után a rendszer rendszeresen ellenőriz, és a klub saját naptára szerinti aktuális hónap tételeit könyveli, pontosan azokat a sorokat, amelyeket az előnézet „Könyvelésre kerül” címkével mutat. A hónap közben kezdődő hozzárendelések továbbra is megvárják az Ön által megadott összeget, a már kiszámlázott hónapot sosem számlázza ki újra, az utolsó automatikus futtatás (sikeres vagy sikertelen) pedig a kapcsoló alatt látható. Bármikor kikapcsolható; a már könyvelt tételek megmaradnak. A fiókon a Kivonat minden tételt, jóváíró számlát, befizetést, sztornót és visszatérítést mutat folyamatos egyenleggel. Válasszon egy napot, hogy lássa a fiókot a nap végén fennálló állapotában, az aznapi lejárt és közelgő tételekkel és jóváírással; a tételek a rögzítésük pillanatától számítanak, ezért egy korábbi kivonat mindig reprodukálható. A CSV letöltése elmenti a kiválasztott nap kivonatát, a fájl tetején a fiókkal és a nappal; minden letöltés bekerül a naplóba. A Hozzáféréssel rendelkező személyek alatt jóváhagyhat egy személyt a fiókhoz jogosultsággal és dátumokkal, vagy visszavonhat egy jóváhagyást; a jóváhagyás fiókonként érvényes, független a gyermekhez fűződő szülői kapcsolattól, a visszavont jóváhagyás pedig azonnal elrejti a fiókot. Ha egy befizetésből még van le nem képzett jóváírás, a Jóváírás képzése felkínálja annak legrégebbi esedékesség szerinti képzését, amelyet módosíthat és megerősíthet. A Jelentések részben válasszon egy napot, és megjelenik a teljes klub tételeinek és befizetéseinek állása a nap végén, pénznemenként külön blokkban, összeadás nélkül. Szűrhet szezonra, arra a csapatra, amelyben a sportoló a tétel esedékességének napján volt, fizetési módra vagy fiókra (a csapatszűrő kihagyja a befizetéseket, a fizetésimód-szűrő a tételeket, mert a tételnek nincs fizetési módja, a befizetésnek pedig nincs csapata). Az egyeztetés összeveti ugyanazon főkönyv tétel-, befizetés-, lekötés-, visszatérítés- és kivonatnézetét, és jelzi az eltéréseket. A CSV letöltése ugyanezeket a számokat menti, felül a nappal és a szűrőkkel; minden letöltés bekerül a naplóba. A Lezárt időszakok résznél a pénzügy egy múltbeli napig zárolhatja a főkönyvet: utána sem kézzel, sem a díjgenerálással nem rögzíthető olyan tétel, amelynek esedékessége vagy befizetési napja a lezárt napon vagy előtte van (a generálás az ilyen hozzárendeléseket kihagyottként, lezárt beszámolási időszak miatt jelzi). A lezárás végleges, és mindig csak előre léphet; a lezárt időszak tételeinek helyesbítéséhez jóváíró számlát, sztornót vagy visszatérítést rögzítsen, amely a nyitott időszak dátumát kapja. Az Importálás részben CSV-fájlt ellenőrizhet számlázási fiókokról, a fiókokhoz rendelt sportolókról, nyitóegyenlegekről vagy befizetésekről (előbb töltse le a sablont; a fiókokat és a sportolókat ugyanabból a forrásból származó külső azonosító nevezi meg, a sportolókat pedig előbb kell importálni). Az ellenőrzés soronként felsorolja a hibákat, és megmutatja az érvényes sorok összesítését, hogy összevethesse a forrástáblázattal. Az importálás egyetlen lépésben csak új tételeket könyvel: a nyitóegyenleg nyitó tétel vagy nyitó jóváírás lesz, az importált befizetés le nem képzett jóváírás marad, a lezárt időszakba eső tételeket elutasítja, ugyanannak a fájlnak az újbóli importálása pedig semmit sem változtat. Az Éves tagdíj csapatonként részben válasszon évet, és állítsa be korosztályonként az éves tagdíjat (például U7–U9 és U11 1000 RON, U13-tól felfelé 1300 RON); a módosítás felülírja az adott év tagdíját, és bekerül a naplóba. Az alatta lévő lista minden számlát mutat a sportolóival és azok csapatával, az éves tagdíjjal, az adott évben befizetett összeggel és a hátralékkal (vagy a túlfizetéssel). A csapat az, amelyben a sportoló az év elején van, vagy amelyhez az év során először csatlakozott. Az évre dátumozott összes befizetés beszámít a visszatérítések nélkül, akkor is, ha nincs díjtételre elszámolva; ha egy számla sportolója nincs csapatban, vagy a korosztályához nincs tagdíj, a számla hiányosként jelenik meg. Szűrhet csapatra, vagy csak a hátralékos számlákat mutathatja. A lista semmit nem könyvel; ha a tagdíjat díjtételként szeretné kiszámlázni, használja a számlán az Éves tagdíj részt.',
  'help.payments':
    'A Befizetések oldal azokat a pénzügyi fiókokat mutatja, amelyek megtekintését a klub jóváhagyta Önnek. Minden fiókhoz saját egyenleg, lejárt tartozás, közelgő tétel és le nem képzett jóváírás tartozik; a különböző fiókok egyenlegét sosem adjuk össze. A Kivonat megjelenítése gombbal az adott fiók minden tétele, befizetése és visszatérítése látható futó egyenleggel, és kiválasztható egy nap, hogy a fiók a nap végén milyen állapotban volt. Egy gyermekhez való kapcsolás nem mutatja meg a gyermek fiókját: a klub pénzügyi csapata személyenként és fiókonként hagyja jóvá a hozzáférést, a jóváhagyás visszavonása pedig azonnal elrejti a fiókot. Ez az oldal csak tájékoztat; a befizetéseket a klub rögzíti. Ha egy összeg hibásnak tűnik, forduljon a klub pénzügyi csapatához.',
  'help.competitions':
    'A versenyszezon egy osztály szezonját köti egy versenyhez (szövetség, kategória, osztály és szakaszok); a versenykezelők (klubadminisztrátorok, titkárok és edzők) hozzák létre. Minden verseny felsorolja a szabályprofil-verzióit. A klubadminisztrátor a mellékelt FRHG 2026–2027 katalógusból indít piszkozatot, rögzíti az elolvasott forrásdokumentumok SHA-256 értékét és azt a napot, amikor a forrásokat módosítások szempontjából ellenőrizte, majd aktiválja a verziót; az aktiválás felváltja az addig aktív verziót, az aktivált verzió pedig soha nem változik. A piszkozat, a felváltott verzió vagy a profil hiánya soha nem hagy jóvá senkit: a szabályosság „felülvizsgálatra vár” marad. A forrást meg nem nevező piszkozat nem aktiválható, és a profilon felsorolt kötelező kézi ellenőrzések nyitva maradnak. A Regisztrációk alatt a versenykezelő a verseny ugyanazon osztályának és szezonjának egy csapatán keresztül regisztrál egy sportolót a versenyre: kiválasztja a regisztráció módját (saját, ideiglenes feljátszás vagy kizárólag magasabb korosztály), az első napot, az opcionális utolsó napot és az opcionális licenchivatkozást. Egy sportoló versenyenként egy napon csak egy aktív regisztrációval rendelkezhet, de egyszerre több versenyre is regisztrálható. A Javítás az utolsó napot vagy a licenchivatkozást módosítja; a Regisztráció lezárása rögzíti az utolsó napot (nem lehet jövőbeli) és az indokot, a regisztrációt pedig előzményként megtartja, ezért az újbóli regisztráció új rekordot hoz létre. A regisztráció nem változtatja a klubtagságot és a kereteket, és csak az látja, aki a sportolót is láthatja. Az Igazoló dokumentumok alatt a versenykezelő rögzíti, hogy egy sportolóhoz létezik egy dokumentum (orvosi alkalmassági igazolás, megállapodás, kölcsönadási vagy átigazolási jóváhagyás), ki állította ki és mely napokon érvényes. Az új rekord döntésre vár: a Jóváhagyás megerősíti, hogy láttad a dokumentumot, az Elutasítás pedig indokkal előzményként megtartja a rekordot. A döntésre váró rekord javítható; a jóváhagyott rekord már nem javítható, csak indokkal visszavonható, a helyettesítő dokumentum pedig új rekord. Csak a jóváhagyott igazolás számít a szabályosság megállapításakor; a döntésre váró vagy elutasított rekord soha. A dokumentum másolatát nem tároljuk, ezért a megjegyzésekbe és indokokba ne írj egészségügyi részleteket. Az Eltiltások alatt a versenykezelő rögzíti, hogy egy sportoló nem játszhat – egy utolsó napig vagy meghatározott számú mérkőzésig –, ebben a versenyben vagy a klub minden versenyében, megadhat döntésszámot is. Amíg az eltiltás érvényben van, javítható (az első nap, az utolsó nap vagy a mérkőzések száma és a döntésszám; a napokban számolt eltiltás napokban marad, a mérkőzésekben számolt mérkőzésekben), letöltöttnek jelölhető vagy indoklással visszavonható. A letöltött vagy visszavont eltiltás előzményként megmarad és soha nem változik. Csak az érvényben lévő eltiltás számít a szabályossághoz. A Mérkőzések alatt a versenykezelő mérkőzést rendel a versenyhez: kiválasztja az osztály még szabad mérkőzés-eseményét (előbb a Naptárban kell létrehozni), a klub csapatát, a szakaszt, az ellenfél megnevezését és a hazai vagy vendég szerepet. Amíg a mérkőzés ütemezett, javítható (szakasz, ellenfél, hazai vagy vendég), a napja után lezárható, vagy indoklással lemondható; a lemondott mérkőzés felszabadítja az eseményt. A lezárás rögzíti, melyik szabályverzió volt érvényben abban a pillanatban, és a mérkőzés megtartja azt, ha később újabb verziót aktiválnak. A lezárt vagy lemondott mérkőzés előzményként megmarad, és soha többé nem változik. A Keret alatt a versenykezelő kijelöli az ütemezett mérkőzés játékosait: keresd meg a sportolót, válaszd ki a mérkőzésen betöltött posztját (kapus, védő vagy csatár) és egy tetszőleges, 0 és 99 közötti mezszámot, amelyet a keret egy másik sportolója sem visel, majd szükség szerint módosítsd vagy töröld a tételeket. Minden módosítás azonnal mentődik. A keret csak addig módosítható, amíg a mérkőzés ütemezett; a lezárt vagy lemondott mérkőzés kerete úgy marad, ahogy volt. A kijelölés nem ellenőrzi a szabályosságot, és nem bizonyítja, hogy a sportoló játszott. A keret Szabályosság részében a versenykezelő a látható keretet a verseny aktív szabályverziója szerint ellenőrzi: minden sportoló és a keret egésze Szabályos, Nem szabályos vagy Felülvizsgálatot igényel eredményt kap, minden okkal és annak forráshelyével, és az eredmény a használt nappal és szabályverzióval együtt mentődik. Aktív szabályverzió nélkül senki sem szabályos. A klubon kívül játszott mérkőzések csak akkor számítanak, ha rögzítve vannak a Máshol játszott mérkőzések alatt, és egy versenykezelő igazolta, hogy az előzmények teljesek; addig, ahol a szabályok napi vagy heti mérkőzésszámot korlátoznak, a legjobb eredmény a Felülvizsgálatot igényel. A sportoló klubbeli többi mérkőzése is beleszámít ezekbe a korlátokba. Ha egy regisztráció, igazolás, eltiltás, a keret vagy az aktív szabályverzió megváltozik, az elmentett eredmény elavultként jelenik meg, és előzményként megmarad, amíg újra nem ellenőrzöd. Az ellenőrzés csak az automatizált szabályokra terjed ki; az alatta felsorolt kézi ellenőrzések nálad maradnak. A regisztráció a szabályok által használt versenybesorolást is rögzíti (általános, lány vagy női válogatott); ez az aktív regisztrációban javítható, és csak a versenykezelők látják. A Keret véglegesítése lefagyasztja egy ütemezett mérkőzés keretét: minden sportolót újra ellenőriz a verseny aktív szabályverziója és a sportoló más, véglegesített keretei szerint, és elutasítja a véglegesítést, ha egy sportoló nem szabályos, vagy a keret szabályt sért. Ahol még valami felülvizsgálatra vár (például mert a klubon kívül játszott mérkőzéseket nem rögzítjük), szavakkal ki kell jelentened, hogy átnézted. A véglegesített keret addig nem módosítható és nem ellenőrizhető újra, amíg indoklással újra nem nyitod; az elmentett ellenőrzés, amelyen véglegesítették, előzményként megmarad. Egy másik keret véglegesítésekor a napi és heti korlátoknál csak a véglegesített keretek számítanak szereplésnek, ezért ha két keret ugyanazt a sportolót nevezi ugyanarra a napra, az elsőként véglegesített marad érvényben, a második pedig elutasításra kerül. A Keret exportálása (CSV) a megjelenített keretet belső használatra szánt fájlként tölti le a mezszámmal, névvel, szereppel és egy friss ellenőrzés eredményével; a fájl mindig belső segédletként van megjelölve, és soha nem szövetségi benyújtás. A fájl megmondja, hogy hivatalosan kész-e, ehhez aktív szabályverzió, teljes egészében felsorolt véglegesített keret, sportolói és kerethiba hiánya, valamint minden kötelező kézi ellenőrzés elvégzettként rögzítése kell; különben tervezet, és felsorolja az okokat. Az Alkalmasság résznél az aktív szabályverzió minden kötelező kézi ellenőrzése elvégzettként rögzíthető: írd le, mit ellenőriztél és melyik napon, hibás rögzítés esetén pedig a Rögzítés visszavonása gombbal, indoklással vond vissza. A rögzítés csak a keret mostani állapotára és a most aktív szabályverzióra érvényes, ezért egy tétel módosítása vagy más szabályok aktiválása újra nyitottá teszi az ellenőrzést; rögzíteni addig lehet, amíg a mérkőzés nincs lemondva, a keret véglegesítése után is. A Máshol játszott mérkőzések alatt a versenykezelő megkeres egy sportolót, és rögzíti minden igazolt mérkőzését, amelyet a klub keretlistáin kívül játszott (a napot, a bajnokságot vagy klubot, és hogy hol igazolták), majd igazolja, hogy minden ilyen mérkőzés rögzítve van egyik naptól a másikig (jövőbeli nem lehet). Az igazolás csak akkor számít egy keretellenőrzésnél, ha legkésőbb a szabályok leghosszabb heti időszakának első napján kezdődik, és legkorábban a mérkőzés előtti napon ér véget, ezért újítsd meg röviddel a mérkőzés előtt; a mérkőzés napján játszott másik mérkőzés csak akkor számít, ha rögzítve van. A rögzítést vagy az igazolást indoklással lehet visszavonni; ami rögzítve lett, soha nem változik, a visszavont előzményként megmarad, a javítás pedig visszavonás és új rögzítés. Ne írj személyes adatot a forrásba vagy a nyilatkozatba. Minden exportálás bekerül a naplóba.',
  'help.reports':
    'Itt lesznek elérhetők a jelentések és exportok, a szerepköröd által látható adatokra korlátozva.',
  'help.settings':
    'A klubadminisztrátorok a Klubadatok részben állítják be a klub adatait: a klub nevét (az oldal fejlécében és az e-mailek feladójaként jelenik meg), a klub e-mailjeinek nyelvét, a naptári napokat és esedékességeket meghatározó időzónát, valamint a pénznemet. A pénznem az új számlázási fiókokra, díjtervekre és éves díjakra vonatkozik; a meglévő fiókok megtartják azt a pénznemet, amelyben megnyitották őket. A klubadminisztrátorok munkatársi szerepkört adhatnak egy másik tagnak, vagy visszavonhatnak egyet; a visszavont szerepkör a tag következő műveleténél megszűnik, és a klubnak mindig marad legalább egy adminisztrátora. A tag fel is függeszthető: azonnal kijelentkeztetjük ebből a klubból, és a visszaaktiválásáig egyetlen szerepkörét sem használhatja, a szerepkörei megmaradnak. Tag törléséhez a klubból használja az Eltávolítás a klubból gombot, és erősítse meg: minden szerepköre visszavonásra kerül, kijelentkeztetjük ebből a klubból, és eltűnik a listáról, a jelenléti, befizetési és egyéb előzmények viszont megmaradnak. Eltávolított tag csak új meghívó elfogadásával térhet vissza; a bejelentkezési fiókját és más klubjait ez nem érinti. A nyelv kiválasztása csak a feliratokat módosítja. A klubadminisztrátorok e-mailben új munkatársat is meghívhatnak: jelöljön be egy vagy több szerepkört (például Klubadminisztrátor, Edző és Titkár), és hozza létre a meghívót; elfogadáskor a meghívott minden bejelölt szerepkört megkap. Az alkalmazás a klub feladócíméről, a klub nyelvén küldi el a meghívót e-mailben; a hivatkozás 72 óráig érvényes, egyszer használható, és várakozás közben visszavonható. A meghívólista rendbetételéhez jelölje ki a lezárult (elfogadott, visszavont vagy lejárt) meghívókat egyenként, vagy használja a Minden lezárult meghívó kijelölése lehetőséget, majd válassza a Kijelöltek törlése gombot, és erősítse meg; a várakozó meghívók csak visszavonás után törölhetők, és a naplóban minden meghívó nyoma megmarad. A hivatkozás egyszer meg is jelenik a Hivatkozás másolása gombbal, így ha az e-mail nem ment el, Ön is elküldheti. A feladócímet az E-mail feladó résznél állíthatja be: a meghívók erről a címről, a klub nevével érkeznek, és a klub levelezőszerverének jogosultnak kell lennie a cím domainjéről küldeni. Feladócím nélkül nem megy ki e-mail. A klubadminisztrátorok azt is beállíthatják, mennyi ideig lehet tétlen a munkatársak és a családok munkamenete, és hány napig tarthat egy munkamenet; az új korlátok a mentés után indított munkamenetekre vonatkoznak. A klubadminisztrátorok feltölthetik a klub logóját (PNG, JPEG vagy WebP); a klub minden tagja látja az oldal fejlécében, és bármikor lecserélhető vagy eltávolítható. A szerepkör melletti Lejárat módosítása gombbal módosíthatod vagy törölheted a lejáratot; mentéskor a tag kijelentkezik ebből a klubból. Saját vagy visszavont szerepkör lejárata nem módosítható. Adminisztrátori szerepkör csak akkor járhat le, ha egy másik aktív klubadminisztrátor szerepköre határozatlan idejű. A teljes klub adminisztrátora saját fiókjához is hozzáadhatja az Edző, Pénzügy vagy Titkár szerepkört, így egy személy is működtetheti a kis klubot. Minden hozzáadást naplózunk, és utána újra be kell jelentkezni; a jelenléthez az Edző, a tagdíjbefizetésekhez a Pénzügy szerepkör szükséges. A tagok a bejelentkezéskor megadott nevükkel és e-mail-címükkel jelennek meg; aki azóta nem jelentkezett be, annál a meghívó e-mail-címe látszik, vagy a „még nem ismert” jelölés. A szülőket a Sportolók oldalon, a Szülő meghívása résznél lehet meghívni.',
  'sessionPolicy.title': 'Bejelentkezési munkamenet korlátai',
  'sessionPolicy.note':
    'A munkatársakat az alábbi tétlenségi percek után, a családi fiókokat a családokra megadott tétlenségi percek után kijelentkeztetjük; minden munkamenet a megadott napok után is lejár. A módosítás a mentés után indított munkamenetekre vonatkozik.',
  'sessionPolicy.loading': 'Munkamenet-korlátok betöltése…',
  'sessionPolicy.staffIdle': 'Munkatársak tétlenségi korlátja (perc)',
  'sessionPolicy.familyIdle': 'Családok tétlenségi korlátja (perc)',
  'sessionPolicy.absolute': 'Munkamenet legnagyobb hossza (nap)',
  'sessionPolicy.save': 'Munkamenet-korlátok mentése',
  'sessionPolicy.saved': 'A munkamenet-korlátok mentve.',
  'mailSettings.title': 'E-mail feladó',
  'mailSettings.note':
    'A meghívó e-maileket erről a címről küldjük, feladóként a klub nevével. Olyan domainhez tartozó címet adjon meg, amelyről a levelezőszerver küldhet, különben a címzettek nem biztos, hogy megkapják a leveleket. Üresen hagyva nem küldünk e-mailt.',
  'mailSettings.address': 'Feladó e-mail-címe',
  'mailSettings.save': 'Feladócím mentése',
  'mailSettings.saved': 'A feladócím mentve.',
  'mailSettings.loading': 'E-mail-beállítások betöltése…',
  'mailSettings.unavailable':
    'Ezen a szerveren még nincs beállítva az e-mail-küldés, így cím megadásával sem megy ki e-mail. Kérje meg az üzemeltetőt a levelezőszerver beállítására.',
  'mailSettings.invalid': 'Adjon meg érvényes e-mail-címet, vagy hagyja üresen a mezőt.',
  'clubData.title': 'Klubadatok',
  'clubData.note':
    'A klub neve az oldal fejlécében és a klub e-mailjeinek feladójaként jelenik meg. A nyelv a klub által küldött e-mailek nyelve, az időzóna határozza meg a klub naptári napjait (például a havi díj esedékességét), a pénznem pedig az új számlázási fiókok, díjtervek és éves díjak pénzneme.',
  'clubData.loading': 'Klubadatok betöltése…',
  'clubData.saved': 'A klubadatok elmentve.',
  'clubData.name': 'A klub neve',
  'clubData.nameRequired': 'Adja meg a klub nevét.',
  'clubData.language': 'A klub nyelve',
  'clubData.languageHelp': 'Ezen a nyelven mennek ki a meghívók és a klub többi e-mailje.',
  'clubData.timezone': 'Időzóna',
  'clubData.timezoneHelp': 'A naptári napok és az esedékességek ezt az időzónát követik.',
  'clubData.currency': 'Pénznem',
  'clubData.currencyHelp':
    'Új fiókok, díjtervek és éves díjak pénzneme. A meglévő fiókok megtartják a pénznemüket.',
  'clubData.save': 'Klubadatok mentése',
  'error.clubData.invalidTimeZone': 'Ez nem ismert időzóna.',
  'billing.accounts.table.account': 'Fiók',
  'billing.accounts.table.actions': 'Műveletek',
  'billing.fees.assign.noPlansInCurrency':
    'A fiók pénznemében nincs havi díjterv. Hozzon létre egyet a Pénzügyek oldal „Díjtervek és havi díjak” részében.',
  'mail.invitation.subject': 'Meghívó: {club}',
  'mail.invitation.greeting': 'Üdvözöljük!',
  'mail.invitation.body':
    '{club} meghívja Önt, hogy csatlakozzon a klubhoz ({app}) a következő szerepkörökkel: {roles}.',
  'mail.invitation.action': 'Meghívó elfogadása',
  'mail.invitation.linkIntro': 'A meghívó hivatkozása:',
  'mail.invitation.expiry': 'A meghívó egyszer használható, és eddig érvényes: {expiresAt}.',
  'mail.invitation.accountExisting':
    'Ezzel az e-mail-címmel már van fiókja, például egy korábbi meghívóból. Nyissa meg a hivatkozást, és jelentkezzen be vele; ne regisztráljon újra. Ha elfelejtette a jelszót, használja a bejelentkezési oldalon az elfelejtett jelszó hivatkozást.',
  'mail.invitation.accountNew':
    'Még nincs fiókja? Nyissa meg a hivatkozást, és válassza a Fiók létrehozása lehetőséget. Ha a bejelentkezési oldal szerint az e-mail-cím már foglalt, akkor már van fiókja: inkább jelentkezzen be, szükség esetén az elfelejtett jelszó hivatkozással. Utána visszajut a meghívóhoz, és elfogadhatja.',
  'mail.invitation.ignore':
    'Ha nem számított erre a meghívóra, hagyja figyelmen kívül ezt az e-mailt; a hivatkozás nélkül semmi sem változik.',
  'logo.title': 'Klublogó',
  'logo.note':
    'A klub minden tagja látja az oldal fejlécében. PNG, JPEG vagy WebP, legfeljebb {kilobytes} KB.',
  'logo.none': 'Még nincs logó.',
  'logo.current': 'A klub jelenlegi logója',
  'logo.choose': 'Logó kiválasztása',
  'logo.replace': 'Logó cseréje',
  'logo.remove': 'Logó eltávolítása',
  'logo.uploaded': 'A logó mentve.',
  'logo.removed': 'A logó eltávolítva.',
  'logo.error.unsupportedType': 'PNG, JPEG vagy WebP képet válasszon.',
  'logo.error.tooLarge': 'A kép túl nagy. Válasszon kisebbet.',
  'roles.title': 'Szerepkörök és hozzáférés',
  'roles.validity.edit': 'Lejárat módosítása',
  'roles.validity.save': 'Lejárat mentése',
  'roles.validity.cancel': 'Mégse',
  'roles.validity.help':
    'Válassz jövőbeli lejárati dátumot, vagy hagyd üresen a határozatlan időhöz. A dátum az eszközöd időzónáját használja. Mentéskor a tag kijelentkezik ebből a klubból. Saját vagy visszavont szerepkör lejárata nem módosítható. Adminisztrátori szerepkör csak akkor járhat le, ha egy másik aktív klubadminisztrátor szerepköre határozatlan idejű.',
  'roles.loading': 'Szerepkörök betöltése…',
  'roles.empty': 'Még egy tag sem rendelkezik olyan szerepkörrel, amelyet Ön kezelhet.',
  'roles.you': '(Ön)',
  'roles.department': 'Szakosztály',
  'roles.scope.organization': 'Teljes klub',
  'roles.status.active': 'Aktív',
  'roles.status.revoked': 'Visszavonva',
  'roles.status.expired': 'Lejárt',
  'roles.until': 'eddig:',
  'roles.revoke': 'Visszavonás',
  'roles.revoke.confirm': 'Visszavonás megerősítése',
  'roles.assign.bundle': 'Munkatársi szerepkör hozzáadása',
  'roles.assign.until': 'Befejező dátum (nem kötelező)',
  'roles.assign.submit': 'Szerepkör hozzáadása',
  'roles.assign.selfHelp':
    'A teljes klub adminisztrátoraként saját fiókodhoz is hozzáadhatod az Edző, Pénzügy vagy Titkár szerepkört. A jelenlét rögzítéséhez az Edző, a tagdíjbefizetések rögzítéséhez a Pénzügy szerepkört válaszd. Minden hozzáadás után jelentkezz be újra az új szerepkör használatához.',
  'roles.loadMore': 'További tagok megjelenítése',
  'roles.member.unnamed': 'A név még nem ismert (a tag következő bejelentkezése után jelenik meg)',
  'roles.member.status.active': 'Aktív',
  'roles.member.status.suspended': 'Felfüggesztve',
  'roles.member.status.invited': 'Meghívva',
  'roles.member.status.revoked': 'Eltávolítva',
  'roles.member.suspend': 'Tag felfüggesztése',
  'roles.member.suspend.confirm': 'Felfüggesztés megerősítése',
  'roles.member.reactivate': 'Tag visszaaktiválása',
  'roles.member.remove': 'Eltávolítás a klubból',
  'roles.member.remove.confirm': 'Eltávolítás megerősítése',
  'roles.member.remove.warning':
    'Az eltávolítás visszavonja a tag minden szerepkörét, kijelentkezteti ebből a klubból, és eltűnik erről a listáról. Az előzményei megmaradnak. Ha vissza szeretné hozni, küldjön neki új meghívót.',
  'roles.bundle.club_admin': 'Klubadminisztrátor',
  'roles.bundle.secretary': 'Titkár',
  'roles.bundle.finance': 'Pénzügy',
  'roles.bundle.coach': 'Edző',
  'roles.bundle.registrar': 'Nyilvántartó (megszüntetett)',
  'roles.bundle.rules_officer': 'Szabályzati felelős (megszüntetett)',
  'roles.bundle.guardian': 'Szülő/gondviselő',
  'roles.bundle.athlete': 'Sportoló',
  'invitations.title': 'Meghívók',
  'invitations.loading': 'Meghívók betöltése…',
  'invitations.empty': 'Még nincs meghívó.',
  'invitations.create.email': 'A meghívandó személy e-mail-címe',
  'invitations.create.submit': 'Meghívó létrehozása',
  'invitations.created':
    'A meghívó elkészült. Az alábbi hivatkozás csak egyszer jelenik meg, és 72 óráig érvényes; ha a meghívottnak nincs fiókja, a bejelentkezési oldalon regisztrálhat.',
  'invitations.link': 'Meghívóhivatkozás',
  'invitations.copy': 'Hivatkozás másolása',
  'invitations.copied': 'Hivatkozás kimásolva',
  'invitations.copyFailed':
    'A hivatkozást nem sikerült kimásolni; jelölje ki, és másolja ki kézzel.',
  'invitations.status.pending': 'Függőben',
  'invitations.status.accepted': 'Elfogadva',
  'invitations.status.revoked': 'Visszavonva',
  'invitations.status.expired': 'Lejárt',
  'invitations.expires': 'lejár',
  'invitations.revoke': 'Meghívó visszavonása',
  'invitations.revoke.confirm': 'Visszavonás megerősítése',
  'invitations.loadMore': 'További meghívók megjelenítése',
  'invitations.create.bundles': 'Felkínált szerepkörök',
  'invitations.create.bundlesHint':
    'Jelöljön be minden szerepkört, amelyet a meghívott kapjon; elfogadáskor mindegyiket megkapja.',
  'invitations.createdRoles': 'Szerepkörök ebben a meghívóban',
  'invitations.delivery.sent': 'A meghívót e-mailben elküldtük ide: {email}.',
  'invitations.delivery.no_sender':
    'Nem ment ki e-mail, mert a klubnak nincs feladócíme. Állítson be egyet az E-mail feladó résznél, vagy küldje el Ön az alábbi hivatkozást.',
  'invitations.delivery.unavailable':
    'Ezen a szerveren nincs beállítva az e-mail-küldés, ezért nem ment ki e-mail. Küldje el Ön az alábbi hivatkozást.',
  'invitations.delivery.failed':
    'A meghívó e-mailt nem sikerült elküldeni. Küldje el Ön az alábbi hivatkozást, vagy vonja vissza a meghívót, és később próbálja újra.',
  'invitations.emailed': 'E-mail elküldve',
  'invitations.select': 'A(z) {email} címre küldött meghívó kijelölése',
  'invitations.selectAll': 'Minden lezárult meghívó kijelölése',
  'invitations.delete': 'Kijelöltek törlése ({count})',
  'invitations.delete.confirm': '{count} meghívó törlésének megerősítése',
  'invitations.delete.cancel': 'Mégse',
  'invitations.delete.hint': 'A várakozó meghívók nem törölhetők; előbb vonja vissza őket.',
  'invitations.deleted': 'Törölt meghívók: {count}.',
  'invitations.familyNote':
    'A szülőket a Sportolók oldalon, a Szülő meghívása résznél lehet meghívni; a 18. életévüket betöltő sportolókat a gondviselői hozzáférés listájáról.',
  'athletes.loading': 'Sportolók betöltése…',
  'athletes.empty': 'Nincs megjeleníthető sportoló.',
  'athletes.search.label': 'Keresés név szerint',
  'athletes.search.submit': 'Keresés',
  'athletes.dateOfBirth': 'Születési dátum',
  'athletes.givenName': 'Utónév',
  'athletes.familyName': 'Vezetéknév',
  'athletes.email': 'E-mail',
  'athletes.phone': 'Telefon',
  'athletes.status.active': 'Aktív',
  'athletes.status.archived': 'Archivált',
  'athletes.status.withdrawn': 'Kilépett',
  'athletes.create.title': 'Sportoló felvétele',
  'athletes.create.submit': 'Sportoló felvétele',
  'athletes.create.anyway': 'Ez egy másik személy – felvétel mindenképp',
  'athletes.edit': 'Adatok szerkesztése',
  'athletes.edit.save': 'Módosítások mentése',
  'athletes.edit.cancel': 'Mégse',
  'athletes.loadMore': 'További sportolók megjelenítése',
  'athletes.saved': 'Mentve.',
  'athletes.table.name': 'Név',
  'athletes.table.status': 'Állapot',
  'athletes.table.actions': 'Műveletek',
  'athletes.action.details': 'Részletek megtekintése',
  'athletes.action.status': 'Állapot módosítása',
  'athletes.action.payment': 'Befizetés rögzítése',
  'athletes.payment.loading': 'Számlázási fiókok betöltése…',
  'athletes.payment.noAccount':
    'Ez a sportoló még nincs számlázási fiókhoz rendelve. Előbb rendeld hozzá egy fiókhoz a Pénzügyek oldalon.',
  'athletes.payment.account': 'Számlázási fiók',
  'athletes.payment.recorded': 'A befizetés rögzítve.',
  'athletes.payment.openAccount': 'Fiók megnyitása',
  'athletes.payment.goToBilling': 'Ugrás a Pénzügyekre',
  'athletes.dialog.close': 'Bezárás',
  'clubMembership.title': 'Klubtagság',
  'clubMembership.loading': 'Tagság betöltése…',
  'clubMembership.empty': 'Nincs rögzített klubtagság.',
  'clubMembership.from': 'Tag ettől:',
  'clubMembership.until': 'eddig:',
  'clubMembership.openEnded': 'nincs befejezés',
  'clubMembership.joinedOn': 'Tag ettől (üresen: ma)',
  'clubMembership.join': 'Tagság kezdete',
  'clubMembership.end': 'Tagság befejezése',
  'clubMembership.end.confirm': 'Befejezés megerősítése',
  'error.athlete.duplicateCandidate':
    'Már létezik ilyen nevű és születési dátumú sportoló. Ha ez egy másik személy, erősítsd meg a felvételt.',
  'error.athlete.dateOfBirthInFuture': 'A születési dátum nem lehet a jövőben.',
  'guardianLinks.title': 'Szülői kapcsolatok',
  'guardianLinks.intro':
    'A kapcsolat csak a jóváhagyásod után ad egy szülőnek hozzáférést egy sportolóhoz. Olyan kapcsolatot nem hagyhatsz jóvá, amelyben te vagy a szülő.',
  'guardianLinks.loading': 'Szülői kapcsolatok betöltése…',
  'guardianLinks.empty': 'Nincs megjeleníthető szülői kapcsolat.',
  'guardianLinks.filter.label': 'Megjelenítés',
  'guardianLinks.filter.all': 'Mind',
  'guardianLinks.status.pending': 'Jóváhagyásra vár',
  'guardianLinks.status.approved': 'Jóváhagyva',
  'guardianLinks.status.rejected': 'Elutasítva',
  'guardianLinks.status.revoked': 'Visszavonva',
  'guardianLinks.athlete': 'Sportoló',
  'guardianLinks.guardian': 'Szülő / gondviselő',
  'guardianLinks.relationship': 'Kapcsolat',
  'guardianLinks.relationship.parent': 'Szülő',
  'guardianLinks.relationship.legal_guardian': 'Törvényes gyám',
  'guardianLinks.relationship.grandparent': 'Nagyszülő',
  'guardianLinks.relationship.other': 'Egyéb',
  'guardianLinks.validFrom': 'Érvényes ettől',
  'guardianLinks.validUntil': 'Érvényes eddig',
  'guardianLinks.openEnded': 'nincs lejárat',
  'guardianLinks.capabilities': 'Mit tehet a szülő',
  'guardianLinks.capability.viewSchedule': 'Láthatja az időbeosztást',
  'guardianLinks.capability.respondRsvp': 'Válaszolhat a részvételi kérésekre',
  'guardianLinks.capability.viewPublishedResults': 'Láthatja a közzétett eredményeket',
  'guardianLinks.capability.viewMembership': 'Láthatja a tagságot',
  'guardianLinks.capability.receiveNotices': 'Kaphat értesítéseket',
  'guardianLinks.approve': 'Jóváhagyás',
  'guardianLinks.reject': 'Elutasítás',
  'guardianLinks.revoke': 'Visszavonás',
  'guardianLinks.revoke.confirm': 'Visszavonás megerősítése',
  'guardianLinks.loadMore': 'További szülői kapcsolatok megjelenítése',
  'guardianLinks.saved': 'Mentve.',
  'guardianLinks.create.title': 'Szülői kapcsolat kérése',
  'guardianLinks.create.submit': 'Kapcsolat kérése',
  'guardianLinks.create.athleteSearch': 'Sportoló keresése név szerint',
  'guardianLinks.create.noMatches': 'Nincs találat',
  'guardianLinks.create.existingGuardian': 'A klubban már szereplő szülő',
  'guardianLinks.create.newGuardian': 'Új szülő',
  'guardianLinks.create.guardianSearch': 'Szülő keresése név szerint',
  'guardianLinks.create.guardianSource': 'Szülő / gondviselő',
  'childRequests.title': 'Gyermek hozzáadása',
  'childRequests.hint':
    'Adja meg gyermeke nevét és születési dátumát úgy, ahogy a klub nyilvántartja. Egy titkár ellenőrzi a kérelmet, és a gyermeket a fiókjához kapcsolja; addig semmit sem lát a gyermekről.',
  'childRequests.note': 'Megjegyzés a titkárnak (nem kötelező)',
  'childRequests.submit': 'Kérelem elküldése',
  'childRequests.sent':
    'A kérelmet elküldtük. A gyermek a titkár jóváhagyása után megjelenik a Gyermekeim között.',
  'childRequests.mine': 'Kérelmeim',
  'childRequests.loading': 'Kérelmek betöltése…',
  'childRequests.empty': 'Még nincs kérelem.',
  'childRequests.withdraw': 'Visszavonás',
  'childRequests.reason': 'Indoklás',
  'childRequests.status.pending': 'Elbírálásra vár',
  'childRequests.status.approved': 'Jóváhagyva',
  'childRequests.status.rejected': 'Elutasítva',
  'childRequests.status.withdrawn': 'Visszavonva',
  'childRequests.review.title': 'Szülők által kért gyermekek',
  'childRequests.review.intro':
    'Jóváhagyás előtt ellenőrizze, hogy a kérelmező valóban a gyermek szülője vagy gondviselője. Válassza ki, melyik sportolóról van szó, vagy hozzon létre új sportolói adatlapot; a jóváhagyás azonnal jóváhagyott szülői kapcsolatot nyit a bejelölve hagyott jogosultságokkal.',
  'childRequests.review.saved': 'A döntés mentve.',
  'childRequests.review.empty': 'Nincs elbírálásra váró kérelem.',
  'childRequests.review.match': 'Melyik sportolóról van szó?',
  'childRequests.review.exact': 'azonos név és születési dátum',
  'childRequests.review.newAthlete': 'Új sportolói adatlap létrehozása a kérelem alapján',
  'childRequests.review.noCandidates': 'Nem található ilyen születési dátumú és nevű sportoló.',
  'childRequests.review.approve': 'Jóváhagyás és összekapcsolás',
  'childRequests.review.reject': 'Elutasítás',
  'childRequests.review.reject.confirm': 'Elutasítás megerősítése',
  'inviteParent.title': 'Szülő meghívása',
  'inviteParent.intro':
    'Adja meg a szülő e-mail-címét és nevét. A meghívó linkjével bejelentkezik, majd hozzáadja a gyermekeit; egyetlen gyermeket sem lát, amíg egy titkár jóvá nem hagyja a kérelmet. Ha a klubnak van feladócíme, az alkalmazás e-mailben elküldi a meghívót; a link egyszer meg is jelenik, és 72 óráig érvényes.',
  'inviteParent.submit': 'Meghívó létrehozása',
  'guardianLinks.create.athletesHint':
    'Adj hozzá egy vagy több sportolót; mindegyikhez külön kapcsolatot kérünk.',
  'guardianLinks.create.chosenAthletes': 'Kiválasztott sportolók',
  'guardianLinks.create.chosenGuardian': 'Kiválasztott szülő',
  'guardianLinks.create.approveNow':
    'A kapcsolatok azonnali jóváhagyása (ellenőriztem a kapcsolatot)',
  'guardianLinks.invite.open': 'Meghívás az alkalmazásba',
  'guardianLinks.invite.hint':
    'A szülőnek még nincs fiókja. A meghívóval bejelentkezhet, és amíg a kapcsolat jóvá van hagyva, látja ezt a gyermeket.',
  'error.guardianLink.selfLink':
    'Senki nem lehet a saját szülője, és senki nem hagyhatja jóvá a saját szülői hozzáférését.',
  'error.guardianLink.alreadyOpen':
    'Ennek a szülőnek már van várakozó vagy jóváhagyott kapcsolata ehhez a sportolóhoz erre az időszakra.',
  'error.guardianLink.invalidState':
    'Ez a kapcsolat már el lett bírálva vagy módosult. Töltsd újra a listát, és ellenőrizd az állapotát.',
  'error.guardianLink.invalidValidity':
    'Az érvényességi időszak nem megfelelő: nem érhet véget a múltban, és nem előzheti meg a kezdetét.',
  'shell.foundationTitle': 'A biztonságos alap elkészült',
  'shell.foundationBody':
    'A funkciók akkor válnak elérhetővé, amikor a jogosultsági és adatvédelmi követelményeik elkészülnek.',
  'shell.help':
    'A nyelv bármikor módosítható. Ez csak a feliratokat változtatja meg; a tárolt dátumok, számok és adatok változatlanok maradnak.',
  'shell.placeholder': 'Ez a terület még nincs bekapcsolva.',
  'shell.skipToContent': 'Ugrás a fő tartalomhoz',
  'login.signIn': 'Bejelentkezés a klubfiókkal',
  'login.error.loginFailed': 'A bejelentkezés nem fejeződött be. Kérjük, próbálja újra.',
  'login.error.providerUnavailable':
    'A bejelentkezési szolgáltatás jelenleg nem érhető el. Kérjük, próbálja újra néhány perc múlva.',
  'error.unauthenticated': 'A folytatáshoz jelentkezzen be.',
  'error.originNotAllowed': 'A kérést letiltottuk, mert nem ebből az alkalmazásból érkezett.',
  'error.csrfInvalid':
    'A biztonsági jogkivonat hiányzik vagy elavult. Töltse újra az oldalt, és próbálja újra.',
  'page.landing': 'Üdvözöljük',
  'help.landing':
    'A bejelentkezés után a klub áttekintő oldalára jut. Ha több klubnak is tagja, itt vagy a felső menüben választhat; az egyes klubok adatai teljesen elkülönülnek. Ha bejelentkezés előtt megnyitott egy meghívót, a rendszer visszaviszi hozzá, hogy elfogadhassa. Ha a fiókja még egy klubhoz sincs kapcsolva, válassza a Meghívó oldal megnyitása gombot, és illessze be a meghívó kódját, vagy nyissa meg újra a linkjét.',
  'account.loading': 'A fiók betöltése…',
  'account.noMembership':
    'A fiókja még nincs klubhoz kapcsolva. Kérjen meghívót a klub titkárától, majd nyissa meg a linkjét, vagy illessze be a kódját a meghívó oldalán.',
  'account.openInvitation': 'Meghívó oldal megnyitása',
  'account.chooseOrganization': 'Válasszon klubot',
  'account.organization': 'Klub',
  'account.signOut': 'Kijelentkezés',
  'invite.tokenLabel': 'Meghívókód',
  'invite.accept': 'Meghívó elfogadása',
  'invite.signInToAccept': 'Jelentkezzen be az elfogadáshoz',
  'invite.createAccount': 'Fiók létrehozása',
  'invite.accountHint':
    'Van már fiókja, például egy korábbi meghívóból? Jelentkezzen be. Ha a bejelentkezési oldal szerint az e-mail-címe már foglalt, akkor van fiókja: jelentkezzen be, szükség esetén az elfelejtett jelszó hivatkozással.',
  'error.unexpected': 'Valami hiba történt. Kérjük, próbálja újra.',
  'error.forbidden': 'Ehhez nincs jogosultsága.',
  'error.mfaRequired':
    'A munkatársi szerepkörökhöz többfaktoros bejelentkezés szükséges. Jelentkezzen ki, majd lépjen be újra, és adja meg a második faktort.',
  'error.import.empty': 'A fájl üres.',
  'error.import.tooLarge': 'A fájl túl nagy; a határ 512 KB szöveg.',
  'error.import.tooManyRows': 'A fájlban több mint 1000 sor van. Ossza kisebb fájlokra.',
  'error.import.tooManyColumns': 'A fájlban túl sok az oszlop.',
  'error.import.cellTooLong': 'Egy cella hosszabb 500 karakternél.',
  'error.import.formula':
    'A fájl képletet vagy =, illetve @ jellel kezdődő cellát tartalmaz. Távolítsa el, majd próbálja újra.',
  'error.import.binary':
    'Csak UTF-8 kódolású CSV szövegfájl fogadható el, táblázat vagy más bináris fájl nem.',
  'error.import.unterminatedQuote': 'Egy idézőjeles érték nincs lezárva.',
  'error.import.headerMismatch':
    'Az első sorban pontosan a sablon oszlopainak kell szerepelniük. Töltse le a sablont, és hasonlítsa össze.',
  'error.import.duplicateHeader': 'Egy oszlopnév kétszer szerepel az első sorban.',
  'error.import.notStaged': 'Ez az importálás már lezárult vagy vissza lett vonva.',
  'error.import.unresolved':
    'Egyes sorokban még hiba van, vagy döntés szükséges, ezért semmi nem lett importálva.',
  'error.import.stale':
    'A klub adatai megváltoztak a fájl ellenőrzése óta, ezért semmi nem lett importálva. Töltse fel újra a fájlt.',
  'error.import.noDecisionNeeded': 'Ehhez a sorhoz nem kell döntés.',
  'error.import.invalidCandidate': 'Válasszon a sorhoz felsorolt meglévő sportolók közül.',
  'error.import.batchClosed': 'Ez az importálás lezárult; a döntések már nem módosíthatók.',
  'error.import.unknownKind': 'Ismeretlen importtípus.',
  'error.billing.unknownAthlete': 'Ez a sportoló nem tartozik ehhez a klubhoz.',
  'error.billing.athleteNotOnAccount':
    'Ez a sportoló nincs hozzárendelve ehhez a számlázási fiókhoz.',
  'error.billing.assignmentOverlap':
    'Ennek a sportolónak már van számlázási fiókja ezekre a napokra.',
  'error.billing.assignmentAlreadyEnded': 'Ennek a hozzárendelésnek már van befejezési dátuma.',
  'error.billing.invalidEnd': 'A befejezés dátuma nem lehet a kezdés előtt.',
  'error.billing.accessAlreadyGranted':
    'Ennek a személynek már van hozzáférése ehhez a fiókhoz. A módosításhoz először vonja vissza.',
  'error.billing.accessAlreadyRevoked': 'Ezt a hozzáférést már visszavonták.',
  'error.billing.invalidValidity': 'Az érvényesség vége nem lehet a kezdete előtt.',
  'error.billing.currencyMismatch': 'A pénznem nem egyezik a számlázási fiók pénznemével.',
  'error.billing.accountClosed': 'Ez a számlázási fiók le van zárva.',
  'error.billing.periodClosed':
    'Ez a dátum lezárt beszámolási időszakba esik. Rögzítse a tételt a nyitott időszakban.',
  'error.billing.periodClose.notPast': 'Időszak csak a mai napot megelőző napig zárható le.',
  'error.billing.periodClose.notAfterLast':
    'A főkönyv már le van zárva erre a napra vagy egy későbbire.',
  'error.billing.creditExceedsOutstanding':
    'A jóváírás nem haladhatja meg a tétel még kifizetetlen összegét. Ha a tétel már ki van fizetve, először vonja vissza a hozzárendelést.',
  'error.billing.refundExceedsAvailable':
    'A visszatérítés nem haladhatja meg a befizetés hozzá nem rendelt értékét. Ha az összeg már hozzá van rendelve, először vonja vissza a hozzárendelést.',
  'error.billing.alreadyReversed': 'Ezt a tételt már visszavonták.',
  'error.billing.notReversible': 'Ez a tétel nem vonható vissza.',
  'error.billing.paymentRefunded': 'A részben visszatérített befizetés nem vonható vissza.',
  'error.billing.allocation.unknownCharge': 'Ez a tétel nem tartozik a befizetés fiókjához.',
  'error.billing.allocation.duplicateCharge':
    'Egy tétel csak egyszer szerepelhet a hozzárendelésben.',
  'error.billing.allocation.notPositive':
    'A hozzárendelt összegnek nullánál nagyobbnak kell lennie.',
  'error.billing.allocation.exceedsOutstanding':
    'A hozzárendelt összeg meghaladja a tétel kifizetetlen összegét.',
  'error.billing.allocation.exceedsPayment':
    'A hozzárendelések meghaladják a befizetés hozzá nem rendelt értékét.',
  'error.billing.fee.planCurrencyChanged':
    'A díjcsomag új verziója megtartja a csomag pénznemét. Másik pénznemhez indítson új csomagot.',
  'error.billing.fee.unknownAccount': 'Ez a számlázási fiók nem létezik.',
  'error.billing.fee.unknownPlan': 'Ez a díjcsomag-verzió nem létezik.',
  'error.billing.fee.planCurrencyMismatch': 'A díjcsomag pénzneme nem egyezik a fiókéval.',
  'error.billing.fee.versionExists':
    'A csomagnak épp most készült másik verziója. Töltse újra az oldalt, és próbálja meg újra.',
  'error.billing.fee.assignmentOverlap':
    'Ennek a sportolónak már van díja ezen a fiókon a megadott időszak egy részére. Előbb zárja le.',
  'error.billing.fee.periodTooFarAhead':
    'A díjfuttatás legfeljebb az aktuális vagy a következő hónapra készíthető.',
  'error.billing.fee.tooManyAssignments':
    'Túl sok díjhozzárendelés érinti ezt a hónapot ahhoz, hogy egyszerre lefusson.',
  'error.billing.fee.reviewNotApplicable':
    'Csak a felülvizsgálatra váró, hónap közbeni első díjhoz adható felülvizsgált összeg.',
  'error.billing.fee.reviewExceedsPlan':
    'A felülvizsgált első díj nem lehet magasabb a kedvezmény utáni díjnál.',
  'error.idempotency.keyRequired': 'Ehhez a művelethez Idempotency-Key fejléc szükséges.',
  'error.idempotency.keyReused': 'Ezt a kulcsot már másik kéréshez használták.',
  'error.idempotency.inProgress':
    'Az ezzel a kulccsal indított korábbi kérés még fut. Próbálja újra egy kis idő múlva.',
  'import.problem.required': 'kötelező',
  'import.problem.too_long': 'túl hosszú',
  'import.problem.invalid_date': 'nem érvényes dátum a választott dátumrendszerben',
  'import.problem.date_in_future': 'a jövőben van',
  'import.problem.invalid_email': 'nem érvényes e-mail-cím',
  'import.problem.invalid_phone': 'nem érvényes telefonszám',
  'import.problem.invalid_locale': 'értéke en, hu vagy ro lehet',
  'import.problem.invalid_relationship':
    'értéke parent, legal_guardian, grandparent vagy other lehet',
  'import.problem.end_before_start': 'a kezdő dátum előtt van',
  'import.problem.duplicate_in_file': 'egy korábbi sort ismétel ebben a fájlban',
  'import.problem.unknown_athlete':
    'olyan sportolót nevez meg, akit ebből a forrásból még nem importáltak',
  'import.problem.athlete_not_active': 'nem aktív sportolót nevez meg',
  'import.problem.membership_overlap': 'átfedésben van a sportoló egy meglévő klubtagságával',
  'imports.title': 'Sportolók, gondviselők és tagságok importálása',
  'imports.intro':
    'Töltsön fel a sablonból készült, UTF-8 kódolású CSV fájlt. Semmi nem kerül mentésre, amíg át nem nézi az ellenőrzött sorokat, és jóvá nem hagyja őket.',
  'imports.kind': 'Mit importál',
  'imports.kind.athletes': 'Sportolók',
  'imports.kind.guardians': 'Gondviselői kapcsolatok (függőben)',
  'imports.kind.memberships': 'Klubtagságok',
  'imports.source': 'Forrásrendszer neve',
  'imports.sourceHelp':
    'A külső azonosítóval együtt ebből ismeri fel ugyanazt a rekordot újabb importáláskor.',
  'imports.dateFormat': 'A fájl dátumrendszere',
  'imports.dateFormat.iso': 'Év-hónap-nap (2026-10-04)',
  'imports.dateFormat.dmy': 'Nap.hónap.év (04.10.2026)',
  'imports.dateFormat.mdy': 'Hónap/nap/év (10/04/2026)',
  'imports.file': 'CSV fájl',
  'imports.fileTooLarge': 'Ez a fájl nagyobb 512 KB-nál.',
  'imports.template': 'Sablon letöltése',
  'imports.stage': 'Fájl ellenőrzése',
  'imports.staged': 'A fájl ellenőrzése megtörtént. Jóváhagyás előtt nézze át az alábbi eredményt.',
  'imports.list': 'Importálások',
  'imports.empty': 'Még nincs importálás.',
  'imports.loading': 'Importálások betöltése…',
  'imports.batchStatus.staged': 'Átvizsgálásra vár',
  'imports.batchStatus.committed': 'Importálva',
  'imports.batchStatus.cancelled': 'Visszavonva',
  'imports.rowStatus.ready': 'Kész',
  'imports.rowStatus.error': 'Hibás',
  'imports.rowStatus.needs_decision': 'Döntésre vár',
  'imports.rowStatus.already_imported': 'Már importálva',
  'imports.rowStatus.skipped': 'Kihagyva',
  'imports.rowStatus.committed': 'Most importálva',
  'imports.review': 'Átnézés',
  'imports.close': 'Bezárás',
  'imports.commit': 'A kész sorok importálása',
  'imports.commit.blocked': 'Előbb javítsa a fájlt, vagy döntsön minden egyező sorról.',
  'imports.cancel': 'Fájl visszavonása',
  'imports.cancel.confirm': 'Visszavonás megerősítése',
  'imports.result': 'Az importálás befejeződött.',
  'imports.result.created': 'Létrehozva',
  'imports.result.linked': 'Meglévő sportolóhoz kapcsolva',
  'imports.result.skipped': 'Kihagyva',
  'imports.result.alreadyImported': 'Már importálva',
  'imports.row': 'Sor',
  'imports.rows.empty': 'Ebben a csoportban nincs sor.',
  'imports.rows.loadMore': 'További sorok',
  'imports.candidates': 'Azonos nevű és születési dátumú meglévő sportolók',
  'imports.decision.create': 'Új sportoló létrehozása',
  'imports.decision.link': 'Ugyanaz a személy: összekapcsolás',
  'imports.decision.skip': 'Sor kihagyása',
  'imports.decision.made': 'Döntés',
  'imports.guardianNote':
    'A gondviselői sorok hozzáférés nélküli, függő kapcsolatokat hoznak létre; titkár hagyja jóvá mindegyiket a Gondviselői kapcsolatok alatt. Senki nem kap meghívót vagy értesítést.',
  'imports.athleteFirstNote':
    'Először a sportolókat importálja. A gondviselői és tagsági sorok a sportolót ugyanabból a forrásból származó külső azonosítóval nevezik meg.',
  'import.problem.invalid_amount':
    'egész szám legyen a legkisebb pénzegységben, elválasztó nélkül (a 25000 jelentése 250,00)',
  'import.problem.invalid_currency': 'RON, EUR vagy HUF lehet',
  'import.problem.currency_mismatch': 'nem egyezik a fiók pénznemével',
  'import.problem.invalid_balance_type': 'értéke due (tartozás) vagy credit (jóváírás) lehet',
  'import.problem.invalid_method': 'értéke cash, bank_transfer, card_terminal vagy other lehet',
  'import.problem.unknown_account':
    'olyan fiókot nevez meg, amelyet még nem importáltak ebből a forrásból',
  'import.problem.account_closed': 'lezárt fiókot nevez meg',
  'import.problem.period_closed': 'már lezárt beszámolási időszakra esik',
  'import.problem.assignment_overlap': 'átfedi a sportoló egy másik számlázási fiókhoz rendelését',
  'import.problem.athlete_not_on_account':
    'olyan sportolót nevez meg, aki nincs ehhez a fiókhoz rendelve',
  'imports.kind.billing_accounts': 'Számlázási fiókok',
  'imports.kind.billing_assignments': 'Sportolók hozzárendelése fiókokhoz',
  'imports.kind.opening_balances': 'Nyitóegyenlegek',
  'imports.kind.payments': 'Befizetések',
  'billing.imports.title': 'Fiókok, nyitóegyenlegek és befizetések importálása',
  'billing.imports.intro':
    'Először ellenőrizze a CSV-fájlt; a rendszer semmit sem könyvel, amíg nem importálja a kész sorokat. A fájl csak új tételeket ad hozzá: a már könyvelt tételeket sosem módosítja vagy írja felül, és senkit sem értesít.',
  'billing.imports.orderNote':
    'Ebben a sorrendben importáljon: fiókok, majd a sportolók hozzárendelése, majd a nyitóegyenlegek, végül a befizetések. A sportolókat előbb ugyanabból a forrásból kell importálni; a sorok a fiókokat és a sportolókat külső azonosítóval nevezik meg.',
  'billing.imports.openingNote':
    'A nyitóegyenleg nyitó tételként (due típus, az as_of napra keltezve) vagy nyitó jóváírásként (credit típus) kerül a főkönyvbe; sosem kerül be múltbeli befizetésként. Az összegek egész számok a legkisebb pénzegységben: a 25000 jelentése 250,00.',
  'billing.imports.paymentsNote':
    'Az importált befizetés teljes összege le nem képzett jóváírásként marad; utólag a fiókból képezze le.',
  'imports.totals': 'Az érvényes sorok összesítése – hasonlítsa össze a forrástáblázattal',
  'imports.totals.opening_due': 'Nyitó tartozások',
  'imports.totals.opening_credit': 'Nyitó jóváírások',
  'imports.totals.payment': 'Befizetések',
  'imports.totals.rows': 'sor',
  'dashboard.secretary.title': 'Mire kell odafigyelnie',
  'dashboard.loading': 'Betöltés…',
  'dashboard.missingGuardianLinks': 'Gondviselői kapcsolat nélküli kiskorúak',
  'dashboard.pendingGuardianLinks': 'Döntésre váró gondviselői kapcsolatok',
  'dashboard.pendingImports': 'Átvizsgálásra váró importálások',
  'dashboard.newJoiners': 'Új belépők az elmúlt 30 napban',
  'dashboard.inactiveAthletes': 'Aktív sportolók érvényes klubtagság nélkül',
  'dashboard.evidenceNote':
    'A lejáró nevezések és igazolások itt jelennek meg, amint léteznek versenynevezések.',
  'dashboard.openAthletes': 'Sportolók oldal megnyitása',
  'hockeyProfile.title': 'Jégkorong-profil',
  'hockeyProfile.positions': 'Preferált posztok',
  'hockeyProfile.position.goalkeeper': 'Kapus',
  'hockeyProfile.position.defender': 'Védő',
  'hockeyProfile.position.forward': 'Csatár',
  'hockeyProfile.stickHand': 'Ütőfogás',
  'hockeyProfile.stickHand.left': 'Bal',
  'hockeyProfile.stickHand.right': 'Jobb',
  'hockeyProfile.none': 'Nincs megadva',
  'hockeyAssessment.skatingSprint': 'Egyenes vonalú korcsolya sprint',
  'hockeyAssessment.puckControlCourse': 'Korongvezetési pálya',
  'hockeyAssessment.shootingAccuracy': 'Lövéspontosság',
  'hockeyAssessment.offIceAgility': 'Jégen kívüli ügyességi pálya',
  'hockeyProfile.save': 'Jégkorong-profil mentése',
  'hockeyProfile.saved': 'A jégkorong-profil mentve.',
  'error.changeRequest.notPending': 'Ezt a kérést már elbírálták vagy visszavonták.',
  'error.changeRequest.ownRequest': 'Saját kérését nem bírálhatja el.',
  'error.changeRequest.athleteChanged':
    'A sportoló adatai időközben megváltoztak. Töltse újra, és bírálja el ismét.',
  'error.childRequest.notPending': 'Ezt a kérelmet már elbírálták vagy visszavonták.',
  'error.childRequest.ownRequest':
    'Nem bírálhat el olyan kérelmet, amelyet Ön nyújtott be, vagy amelyben Ön a szülő.',
  'error.childRequest.noGuardianRecord':
    'A fiókja ebben a klubban még nincs szülői adatlaphoz kapcsolva. Kérje meg a klubot, hogy hívja meg szülőként.',
  'error.childRequest.unknownAthlete': 'A kiválasztott sportoló nem létezik ebben a klubban.',
  'error.childRequest.alreadyPending': 'Ehhez a gyermekhez már van elbírálásra váró kérelme.',
  'changeRequests.title': 'Módosítási kérelmek',
  'changeRequests.open': 'Módosítás kérése',
  'changeRequests.hint':
    'Csak azt töltse ki, amit módosítani kell. A kérelmet titkár bírálja el; jóváhagyásig semmi nem változik.',
  'changeRequests.note': 'Megjegyzés a titkárnak (nem kötelező)',
  'changeRequests.submit': 'Kérelem küldése',
  'changeRequests.cancel': 'Mégse',
  'changeRequests.sent': 'A kérelem elbírálásra elküldve.',
  'changeRequests.withdraw': 'Visszavonás',
  'changeRequests.status.pending': 'Elbírálásra vár',
  'changeRequests.status.approved': 'Jóváhagyva',
  'changeRequests.status.rejected': 'Elutasítva',
  'changeRequests.status.withdrawn': 'Visszavonva',
  'changeRequests.review.title': 'Elbírálandó módosítási kérelmek',
  'changeRequests.sensitive': 'név vagy születési dátum: ellenőrizzen igazolást',
  'changeRequests.approve': 'Jóváhagyás és alkalmazás',
  'changeRequests.reject': 'Elutasítás',
  'changeRequests.reject.confirm': 'Elutasítás megerősítése',
  'changeRequests.reason': 'Indoklás',
  'error.notFound': 'Ez az elem nem létezik, vagy nincs hozzáférése.',
  'error.validation': 'Néhány adat érvénytelen. Ellenőrizze, majd próbálja újra.',
  'error.logo.invalidImage':
    'A kép érvénytelen vagy túl nagy. PNG, JPEG vagy WebP képet válasszon a méretkorláton belül.',
  'error.versionConflict': 'Ezt az elemet valaki más módosította. Töltse újra, és próbálja újra.',
  'error.preconditionRequired':
    'A kérés nem jelöli meg, melyik verziót módosítja. Töltse újra az oldalt, és próbálja újra.',
  'error.invitation.invalid':
    'Ez a meghívókód érvénytelen. Ellenőrizze, hogy teljesen átmásolta-e.',
  'error.invitation.expired': 'Ez a meghívó lejárt. Kérjen újat a klub titkárától.',
  'error.invitation.revoked': 'Ezt a meghívót visszavonták. Kérjen újat a klub titkárától.',
  'error.invitation.alreadyUsed': 'Ezt a meghívót már felhasználták, vagy már nem függőben lévő.',
  'error.invitation.ownInvitation': 'A saját maga által létrehozott meghívót nem fogadhatja el.',
  'error.invitation.membershipBlocked':
    'A klubtagsága jelenleg nem fogadhatja el ezt a meghívót. Forduljon a klub titkárához.',
  'error.invitation.roleNotAllowed': 'Ehhez a szerepkörhöz nem hívhat meg személyeket.',
  'error.invitation.personRequired':
    'A szülői és a sportolói meghívóhoz ellenőrzött személykapcsolat kell; a munkatársi meghívóhoz nem tartozhat ilyen.',
  'error.invitation.stillPending':
    'Várakozó meghívó nem törölhető; előbb vonja vissza. Frissítse a listát, és próbálja újra.',
  'error.invitation.unknownDepartment': 'A kiválasztott szakosztály nem létezik ebben a klubban.',
  'error.role.notAssignable':
    'Ez a szerepkör itt nem adható ki. A szülői és a sportolói szerepkör csak ellenőrzött személykapcsolatot tartalmazó meghívóval szerezhető meg.',
  'error.role.memberInactive': 'Ez a tagság nem aktív, ezért nem kaphat szerepkört.',
  'error.role.unknownDepartment': 'A kiválasztott szakosztály nem létezik ebben a klubban.',
  'error.role.alreadyAssigned':
    'Ez a személy már rendelkezik ezzel a szerepkörrel a kiválasztott hatókörben.',
  'error.role.alreadyRevoked': 'Ez a szerepkör már vissza lett vonva.',
  'error.role.invalidValidity': 'A befejező dátumnak a jövőben kell lennie.',
  'error.role.lastAdministrator':
    'A klubnak legalább egy aktív klubadminisztrátorra van szüksége. Előbb jelöljön ki másikat.',
  'error.member.notChangeable':
    'Ez a tagság már nincs olyan állapotban, amely lehetővé tenné ezt a módosítást. Töltse újra a listát, és próbálja meg ismét.',
  'error.member.lastAdministrator':
    'A klubnak legalább egy aktív klubadminisztrátorra van szüksége. Előbb jelöljön ki másikat.',
  'teams.department': 'Szakosztály',
  'teams.noDepartments': 'Nincs megjeleníthető szakosztály.',
  'teams.loading': 'Betöltés…',
  'teams.saved': 'Mentve.',
  'teams.season.select': 'Szezon',
  'teams.season.none': 'Még nincs szezon.',
  'teams.season.name': 'Szezon neve',
  'teams.season.startsOn': 'Kezdete',
  'teams.season.endsOn': 'Vége',
  'teams.season.status.draft': 'Tervezet',
  'teams.season.status.active': 'Aktív',
  'teams.season.status.closed': 'Lezárva',
  'teams.season.create.title': 'Szezon felvétele',
  'teams.season.create.submit': 'Szezon felvétele',
  'teams.season.activate': 'Szezon aktiválása',
  'teams.season.close': 'Szezon lezárása',
  'teams.season.close.confirm': 'Lezárás megerősítése',
  'teams.teams.title': 'Csapatok',
  'teams.teams.empty': 'Ebben a szezonban még nincs csapat.',
  'teams.team.name': 'Csapat neve',
  'teams.team.category': 'Korosztály',
  'teams.team.division': 'Bajnoki osztály (nem kötelező)',
  'teams.team.ordinal': 'Csapat sorszáma',
  'teams.team.create.title': 'Csapat felvétele',
  'teams.team.create.submit': 'Csapat felvétele',
  'teams.category.U7_U9': 'U7–U9',
  'teams.category.U11': 'U11',
  'teams.category.U13': 'U13',
  'teams.category.U15': 'U15',
  'teams.category.U17': 'U17',
  'teams.category.U20': 'U20',
  'teams.groups.title': 'Edzéscsoportok',
  'teams.groups.empty': 'Ebben a szezonban még nincs edzéscsoport.',
  'teams.group.name': 'Csoport neve',
  'teams.group.create.title': 'Edzéscsoport felvétele',
  'teams.group.create.submit': 'Csoport felvétele',
  'teams.roster.show': 'Tagok mutatása',
  'teams.roster.hide': 'Tagok elrejtése',
  'teams.roster.empty': 'Nincs tag.',
  'teams.roster.includeEnded': 'A lezárt beosztások is',
  'teams.roster.from': 'Ettől',
  'teams.roster.until': 'Eddig',
  'teams.roster.shirt': 'Mezszám',
  'teams.roster.add.title': 'Tag hozzáadása',
  'teams.roster.add.athlete': 'Sportoló keresése név szerint',
  'teams.roster.add.noMatches': 'Nincs találat',
  'teams.roster.add.submit': 'Hozzáadás a kerethez',
  'teams.roster.end': 'Beosztás lezárása',
  'teams.roster.end.confirm': 'Lezárás megerősítése',
  'teams.roster.openEnded': 'nincs vége',
  'error.structure.unknownCategory': 'Ez a korosztály nem érhető el a szakosztály sportágában.',
  'error.structure.invalidPeriod': 'A befejezés dátuma nem lehet a kezdet előtt.',
  'error.structure.invalidState':
    'Ez a szezon már nincs olyan állapotban, amely lehetővé tenné ezt a módosítást. Töltsd újra az oldalt, és próbáld meg újra.',
  'error.structure.notOpen':
    'A szezon vagy a csapat lezárt vagy archivált, ezért már nem módosítható.',
  'error.structure.alreadyExists': 'Ebben a szakosztályban és szezonban már van ilyen nevű elem.',
  'error.structure.membershipOverlap':
    'Ennek a sportolónak már van itt átfedő időszakra szóló beosztása.',
  'error.structure.shirtNumberTaken': 'Ezt a mezszámot ezeken a napokon már másik tag használja.',
  'error.structure.athleteNotActive':
    'Csak aktív sportolót lehet csapatba vagy csoportba beosztani.',
  'error.structure.alreadyEnded': 'Ennek a beosztásnak már van befejező dátuma.',
  'error.structure.invalidEnd': 'A befejezés dátuma nem lehet a beosztás kezdete előtt.',
  'error.clubMembership.overlap':
    'Ennek a sportolónak már van a megadott napokkal átfedő klubtagsága.',
  'error.clubMembership.athleteNotActive': 'Csak aktív sportoló kezdhet klubtagságot.',
  'error.clubMembership.alreadyEnded': 'Ennek a tagságnak már van befejezési dátuma.',
  'error.clubMembership.invalidEnd': 'A befejezés dátuma nem lehet a tagság kezdete előtt.',
  'calendar.loading': 'Események betöltése…',
  'calendar.empty': 'Ebben az időszakban nincs esemény.',
  'calendar.saved': 'Mentve.',
  'calendar.loadMore': 'További események mutatása',
  'calendar.staff.title': 'Klubnaptár',
  'calendar.family.title': 'Közelgő események',
  'calendar.family.empty': 'Nincs közelgő esemény.',
  'calendar.filter.from': 'Ettől',
  'calendar.filter.to': 'Eddig',
  'calendar.filter.department': 'Szakosztály',
  'calendar.filter.status': 'Állapot',
  'calendar.filter.all': 'Mind',
  'calendar.type.on_ice_training': 'Jégedzés',
  'calendar.type.off_ice_training': 'Száraz edzés',
  'calendar.type.match': 'Mérkőzés',
  'calendar.type.assessment': 'Felmérés',
  'calendar.type.meeting': 'Megbeszélés',
  'calendar.status.draft': 'Tervezet',
  'calendar.status.published': 'Közzétéve',
  'calendar.status.cancelled': 'Lemondva',
  'calendar.status.completed': 'Lezajlott',
  'calendar.field.type': 'Típus',
  'calendar.field.title': 'Megnevezés',
  'calendar.field.date': 'Dátum',
  'calendar.field.startTime': 'Kezdés',
  'calendar.field.endTime': 'Befejezés',
  'calendar.field.location': 'Helyszín (nem kötelező)',
  'calendar.field.resource': 'Pálya, pályarész vagy terem',
  'calendar.field.noResource': 'Nincs szükség erőforrásra',
  'calendar.field.capacity': 'Létszámkorlát (nem kötelező)',
  'calendar.field.arrival': 'Érkezés ennyi perccel a kezdés előtt (nem kötelező)',
  'calendar.field.rsvpHours': 'A családok ennyi órával a kezdés előttig válaszolhatnak',
  'calendar.create.title': 'Esemény felvétele',
  'calendar.create.submit': 'Esemény felvétele',
  'calendar.create.submitSeries': 'Ismétlődő sorozat felvétele',
  'calendar.create.repeat': 'Rendszeres ismétlés',
  'calendar.create.weekdays': 'Ismétlődés ezeken a napokon',
  'calendar.create.until': 'Ismétlődés eddig (nem kötelező)',
  'calendar.create.publishAll': 'Minden alkalom közzététele most',
  'calendar.create.leadSelf': 'Én vezetem ezt az alkalmat',
  'calendar.create.created': 'Az esemény tervezetként felvéve. Nyissa meg a közzétételhez.',
  'calendar.create.seriesResult': 'Létrehozott események:',
  'calendar.create.seriesConflicts': 'Tervezetként maradt, mert az erőforrás már foglalt volt:',
  'calendar.create.seriesUnpublished': 'Tervezetként maradt, mert nem lehetett közzétenni:',
  'calendar.audience.title': 'Kik a meghívottak',
  'calendar.audience.season': 'Szezon',
  'calendar.audience.teams': 'Csapatok',
  'calendar.audience.groups': 'Edzéscsoportok',
  'calendar.audience.none': 'Ebben a szezonban nincs csapat vagy csoport.',
  'calendar.audience.athlete': 'Sportoló hozzáadása név szerint',
  'calendar.audience.noMatches': 'Nincs találat',
  'calendar.audience.remove': 'Eltávolítás',
  'calendar.audience.hint':
    'Jelölj be teljes csapatokat vagy csoportokat, vagy nyisd meg egy névsort, és csak a szükséges játékosokat jelöld be, akár több csapatból is.',
  'calendar.audience.pickFromRoster': 'Játékosok kiválasztása',
  'calendar.audience.hideRoster': 'Játékosok elrejtése',
  'calendar.audience.rosterEmpty': 'Ma senki sincs ezen a névsoron.',
  'calendar.audience.picked': 'Egyenként meghívva',
  'calendar.audience.publishedHint':
    'Mentéskor a résztvevők azonnal frissülnek: az újonnan meghívottak bekerülnek, aki pedig már válaszolt vagy van rögzített jelenléte, a helyén marad.',
  'calendar.action.restore': 'Esemény visszaállítása',
  'calendar.series.title': 'Ismétlődő sorozat',
  'calendar.series.everyWeek': 'Minden héten: {days}',
  'calendar.series.everyNthWeek': '{weeks} hetente: {days}',
  'calendar.series.interval': 'Ismétlés',
  'calendar.series.intervalOne': 'Minden héten',
  'calendar.series.intervalMany': '{weeks} hetente',
  'calendar.series.noEnd': 'Nincs záró dátum.',
  'calendar.series.until': 'Eddig: {date}.',
  'calendar.series.ended': 'Ez a sorozat véget ért, új alkalom nem készül.',
  'calendar.series.upcoming': 'Következő alkalmak',
  'calendar.series.upcomingHint':
    'Vedd ki a pipát egy alkalomnál, ha csak azt akarod lemondani, például a holnapi edzést; ha újra bejelölöd, visszaáll.',
  'calendar.series.none': 'A következő hónapokban nincs tervezett alkalom.',
  'calendar.series.defaultCancelReason': 'Ez az alkalom elmarad.',
  'calendar.series.defaultRescheduleReason': 'Megváltozott az edzésrend.',
  'calendar.series.ownTime': 'Egyedileg módosítva',
  'calendar.series.confirmCancel': 'Alkalom lemondása',
  'calendar.series.confirmRestore': 'Alkalom visszaállítása',
  'calendar.series.restoreAnyway': 'Visszaállítás mégis',
  'calendar.series.keep': 'Hagyd így',
  'calendar.series.notify':
    'A meghívott családok értesítése (az értesítések bekapcsolása után megy ki)',
  'calendar.series.cancelledOne': 'Az alkalom lemondva.',
  'calendar.series.restoredOne': 'Az alkalom visszaállítva.',
  'calendar.series.rescheduled':
    'Az időrend megváltozott: {kept} alkalom maradt, {cancelled} elmarad, {created} új.',
  'calendar.series.change': 'Időrend módosítása',
  'calendar.series.changeHint':
    'A választott naptól kezdve a megmaradó napok alkalmai megtartják a válaszokat és a jelenlétet, és átkerülnek az új időpontra; a kimaradó napok alkalmai az alábbi indoklással elmaradnak; az új napokra új alkalmak készülnek. A korábbi alkalmak nem változnak.',
  'calendar.series.fromDate': 'Érvényes ettől',
  'calendar.series.removedReason': 'A kimaradó alkalmaknál látható indoklás',
  'calendar.series.saveChange': 'Új időrend mentése',
  'calendar.weekday.1': 'Hétfő',
  'calendar.weekday.2': 'Kedd',
  'calendar.weekday.3': 'Szerda',
  'calendar.weekday.4': 'Csütörtök',
  'calendar.weekday.5': 'Péntek',
  'calendar.weekday.6': 'Szombat',
  'calendar.weekday.7': 'Vasárnap',
  'calendar.detail.open': 'Megnyitás',
  'calendar.detail.close': 'Bezárás',
  'calendar.detail.resource': 'Erőforrás',
  'calendar.detail.arrival': 'Érkezés legkésőbb',
  'calendar.detail.capacity': 'Létszámkorlát',
  'calendar.detail.deadline': 'Válasz határideje',
  'calendar.detail.series': 'Ismétlődő sorozat tagja.',
  'calendar.detail.exception': 'Ezt az alkalmat külön szerkesztették.',
  'calendar.detail.notReserved':
    'Az erőforrás még nincs lefoglalva, ezért az esemény nem tehető közzé. Szabadítsa fel az időpontot, vagy válasszon másikat.',
  'calendar.detail.cancelReason': 'A lemondás oka',
  'calendar.action.publish': 'Közzététel',
  'calendar.action.publishAnyway': 'Közzététel mindenképp',
  'calendar.action.cancel': 'Esemény lemondása',
  'calendar.action.cancelReason': 'Indok (a családok látni fogják)',
  'calendar.action.cancelConfirm': 'Lemondás megerősítése',
  'calendar.action.cancelFuture': 'A későbbi alkalmak lemondása is',
  'calendar.action.complete': 'Megjelölés lezajlottként',
  'calendar.action.edit': 'Szerkesztés',
  'calendar.action.save': 'Módosítások mentése',
  'calendar.action.discard': 'Szerkesztés elvetése',
  'calendar.scope.title': 'A módosítás hatóköre',
  'calendar.scope.this': 'Csak erre az alkalomra',
  'calendar.scope.future': 'Erre és az összes későbbi alkalomra',
  'calendar.overlap.notice': 'Néhány sportolót ugyanekkor már egy másik eseményre várnak.',
  'calendar.participants.title': 'Résztvevők',
  'calendar.participants.empty': 'Még senkit nem várnak. A résztvevők közzétételkor kerülnek be.',
  'calendar.participants.answers': 'Válaszok',
  'calendar.rsvp.yes': 'Igen',
  'calendar.rsvp.no': 'Nem',
  'calendar.rsvp.tentative': 'Talán',
  'calendar.rsvp.none': 'Nincs válasz',
  'calendar.rsvp.corrected': 'A határidő után javítva',
  'calendar.rsvp.correct': 'Válasz javítása',
  'calendar.rsvp.reason': 'Indok (a határidő után kötelező)',
  'calendar.rsvp.save': 'Válasz mentése',
  'calendar.refresh.check': 'Tagsági változások ellenőrzése',
  'calendar.refresh.upToDate': 'A résztvevők megfelelnek a csapatoknak és csoportoknak.',
  'calendar.refresh.toAdd': 'Hozzáadandó',
  'calendar.refresh.toRemove': 'Eltávolítandó',
  'calendar.refresh.retained': 'Marad, mert válaszolt vagy rögzítettek jelenlétet',
  'calendar.refresh.apply': 'Változások alkalmazása',
  'calendar.attendance.title': 'Jelenlét',
  'calendar.attendance.present': 'Jelen',
  'calendar.attendance.late': 'Késett',
  'calendar.attendance.absent_excused': 'Igazolt',
  'calendar.attendance.absent_unexcused': 'Hiányzik',
  'calendar.attendance.not_recorded': 'Nincs rögzítve',
  'calendar.attendance.markAll': 'Mindenki jelen van',
  'calendar.attendance.save': 'Jelenlét mentése',
  'calendar.attendance.unsaved': 'Nem mentett módosítások',
  'calendar.attendance.saved': 'A jelenlét mentve.',
  'calendar.attendance.conflict':
    'Valaki más módosította ezt a sort; az ő bejegyzése látható. Válasszon újra a felülíráshoz.',
  'calendar.attendance.conflictSummary': 'Másvalaki által módosított sorok:',
  'calendar.attendance.notOpen': 'A jelenlét az esemény közzététele után rögzíthető.',
  'calendar.attendance.readOnly': 'A jelenlétet megtekintheti, de nem rögzítheti.',
  'calendar.summary.title': 'Jelenléti arány',
  'calendar.summary.show': 'Jelenléti arányok mutatása erre az időszakra',
  'calendar.summary.athlete': 'Sportoló',
  'calendar.summary.rate': 'Arány',
  'calendar.summary.total': 'Összesen',
  'calendar.summary.empty': 'Ebben az időszakban nincs rögzített jelenlét.',
  'calendar.summary.definition':
    'Jelenléti arány = (jelen + késett) ÷ (jelen + késett + igazolt hiányzás + igazolatlan hiányzás) a kiválasztott időszakban. A lemondott események, a nem rögzített sorok és a nem résztvevő sportolók nem számítanak. Az igazolt hiányzások külön látszanak.',
  'calendar.family.attending': 'Részt vesz?',
  'calendar.family.answer': 'Válasz',
  'calendar.family.closed': 'A válaszadás lezárult.',
  'calendar.family.cancelledNotice': 'Ezt az eseményt lemondták.',
  'calendar.venues.title': 'Helyszínek és erőforrások',
  'calendar.venues.intro':
    'A foglalható pályarészekkel rendelkező jégpálya egy pályaként kerül felvételre, alatta a pályarészekkel. A teljes pálya foglalása az összes részét blokkolja; a foglalás utáni takarítási idő távol tartja a következő foglalást.',
  'calendar.venues.empty': 'Még nincs helyszín.',
  'calendar.venue.name': 'Helyszín neve',
  'calendar.venue.add': 'Helyszín felvétele',
  'calendar.resource.name': 'Erőforrás neve',
  'calendar.resource.kind': 'Fajta',
  'calendar.resource.parent': 'Része ennek',
  'calendar.resource.none': 'Semmi (legfelső szint)',
  'calendar.resource.surface': 'Felület',
  'calendar.resource.setup': 'Előkészítés percben a foglalás előtt',
  'calendar.resource.cleanup': 'Takarítás percben a foglalás után',
  'calendar.resource.add': 'Erőforrás felvétele',
  'calendar.resourceKind.rink': 'Jégpálya',
  'calendar.resourceKind.zone': 'Pályarész',
  'calendar.resourceKind.room': 'Terem',
  'calendar.resourceKind.field': 'Pálya',
  'calendar.surface.ice': 'Jég',
  'calendar.surface.dryland': 'Száraz felület',
  'calendar.surface.other': 'Egyéb',
  'error.scheduling.invalidTimeZone': 'Ez az időzóna érvénytelen.',
  'error.scheduling.invalidSchedule':
    'A befejezésnek a kezdés után kell lennie, és egy esemény legfeljebb két hétig tarthat.',
  'error.scheduling.unknownResource': 'Ez a helyszín vagy erőforrás nem használható az eseményhez.',
  'error.scheduling.unknownAudience':
    'A meghívottak között szereplő csapat, csoport vagy sportoló nem tartozik ehhez a szakosztályhoz.',
  'error.scheduling.unknownStaff': 'A munkatársaknak a szakosztály aktív edzőinek kell lenniük.',
  'error.scheduling.unknownVenue': 'Ez a helyszín nem létezik.',
  'error.scheduling.invalidParent': 'Az erőforrás szülőjének ugyanabban a helyszínben kell lennie.',
  'error.scheduling.alreadyExists': 'Itt már van ilyen nevű elem.',
  'error.scheduling.resourceConflict':
    'Az erőforrás ekkor már foglalt, az előkészítési és takarítási időt is beleértve. Válasszon másik időpontot vagy erőforrást.',
  'error.scheduling.staffConflict': 'Az egyik megnevezett edzőnek ekkor már van másik eseménye.',
  'error.scheduling.athleteOverlap':
    'Néhány sportolót ekkor már egy másik közzétett eseményre várnak. A megerősítéshez tegye közzé mindenképp.',
  'error.scheduling.capacityExceeded':
    'A sportolók száma meghaladja az esemény vagy az erőforrás létszámkorlátját.',
  'error.scheduling.invalidState':
    'Az esemény már nincs olyan állapotban, hogy ez megtehető legyen. Töltse újra, és próbálja újra.',
  'error.scheduling.notEditable': 'Lemondott vagy lezajlott esemény már nem módosítható.',
  'error.scheduling.noAudience':
    'A közzététel előtt válasszon legalább egy csapatot, csoportot vagy sportolót.',
  'error.scheduling.rsvpClosed':
    'A válaszadási határidő lejárt. Kérje meg az edzőt a válasz javítására.',
  'error.scheduling.rsvpNotAllowed': 'Csak közzétett eseményekre lehet válaszolni.',
  'error.scheduling.rsvpReasonRequired': 'A határidő utáni javításhoz meg kell adni az indokot.',
  'error.scheduling.attendanceNotOpen':
    'Jelenlét csak közzétett vagy lezajlott eseményhez rögzíthető.',
  'error.scheduling.seriesInvalid': 'Ez a heti ismétlődés így nem hozható létre vagy módosítható.',
  'error.scheduling.seriesNotOccurrence': 'Ez az esemény nem tartozik heti ismétlődő sorozathoz.',
  'error.scheduling.reschedulePast': 'Az új rend csak mától vagy későbbtől indulhat.',
  'training.loading': 'Betöltés…',
  'training.saved': 'Mentve.',
  'training.drills.title': 'Gyakorlatok',
  'training.drills.empty': 'Még nincs gyakorlat.',
  'training.drill.title': 'Megnevezés (az aktuális nyelven)',
  'training.drill.minutes': 'Időtartam (perc)',
  'training.drill.equipment': 'Eszközök (vesszővel elválasztva)',
  'training.drill.instructions': 'Edzői útmutató (csak munkatársaknak)',
  'training.drill.protocol': 'Protokoll (nem kötelező)',
  'training.drill.add': 'Gyakorlat felvétele',
  'training.drill.edit': 'Szerkesztés új változatként',
  'training.drill.newVersion': 'Mentés új változatként',
  'training.drill.version': 'Változat',
  'training.drill.department': 'Elérhető ehhez',
  'training.drill.wholeClub': 'Az egész klub',
  'training.plans.title': 'Edzéstervek',
  'training.plans.empty': 'Még nincs edzésterv.',
  'training.plan.new': 'Új edzésterv',
  'training.plan.open': 'Megnyitás',
  'training.plan.close': 'Bezárás',
  'training.plan.state.draft': 'Tervezet',
  'training.plan.state.published': 'Közzétéve',
  'training.plan.state.archived': 'Archiválva',
  'training.plan.title': 'Az edzésterv címe',
  'training.plan.objective': 'Cél (nem kötelező)',
  'training.plan.sessionMinutes': 'Az alkalom hossza (perc)',
  'training.plan.prepMinutes': 'Előkészítés (perc)',
  'training.plan.breakMinutes': 'Szünetek (perc)',
  'training.plan.override': 'Indok, ha a terv többet tartalmaz a beleférőnél (nem kötelező)',
  'training.plan.active': 'Tervezett aktív idő',
  'training.plan.available': 'rendelkezésre áll',
  'training.plan.minutes': 'perc',
  'training.plan.fits': 'A terv belefér az alkalomba.',
  'training.plan.doesNotFit':
    'A terv hosszabb, mint amit az alkalom enged. Rövidítse, vagy adjon indokot.',
  'training.plan.blocks': 'Blokkok',
  'training.plan.versions': 'Változatok',
  'training.block.objective': 'A blokk célja',
  'training.block.minutes': 'Percek',
  'training.block.drill': 'Gyakorlat',
  'training.block.noDrill': 'Nincs gyakorlat',
  'training.block.intensity': 'Intenzitás',
  'training.block.equipment': 'Eszközök',
  'training.block.surface': 'Felület',
  'training.block.notes': 'Edzői jegyzetek (a családok soha nem látják)',
  'training.block.familyVisible': 'Összefoglaló megjelenítése a családoknak',
  'training.block.familySummary': 'Összefoglaló a családoknak',
  'training.block.add': 'Blokk hozzáadása',
  'training.block.remove': 'Blokk törlése',
  'training.block.up': 'Feljebb',
  'training.block.down': 'Lejjebb',
  'training.block.stationsNote':
    'Párhuzamos állomásoknál a blokk a leghosszabb állomás ideig tart.',
  'training.station.add': 'Párhuzamos állomás hozzáadása',
  'training.station.label': 'Állomás',
  'training.station.remove': 'Állomás törlése',
  'training.intensity.low': 'Alacsony',
  'training.intensity.medium': 'Közepes',
  'training.intensity.high': 'Magas',
  'training.action.create': 'Edzésterv létrehozása',
  'training.action.save': 'Tervezet mentése',
  'training.action.publish': 'Változat közzététele',
  'training.action.newDraft': 'Új változat indítása ebből',
  'training.action.frozen':
    'Ez a változat közzé van téve, és már nem módosítható. Új változat indításával szerkeszthető.',
  'training.attach.title': 'Edzésterv',
  'training.attach.none': 'Nincs edzésterv',
  'training.attach.save': 'Ezt a tervet használja',
  'training.attach.override': 'Indok egy az alkalomnál hosszabb terv használatára',
  'training.attach.help':
    'Csak közzétett tervváltozat használható. A sablon későbbi módosítása nem változtatja meg a már használt alkalmat.',
  'calendar.family.plan': 'Az alkalom terve',
  'error.training.unknownDrill':
    'A tervben szereplő egyik gyakorlat nem érhető el ennél a szakosztálynál.',
  'error.training.invalidState': 'Ez a változat már nem tervezet.',
  'error.training.draftExists':
    'Ennek a tervnek már van tervezete. Előbb fejezze be vagy tegye közzé.',
  'error.training.activeTimeExceeds':
    'A tervezett aktív idő hosszabb, mint amit az alkalom az előkészítés és a szünetek után enged. Rövidítse a tervet, vagy adjon indokot.',
  'error.training.planDoesNotFit':
    'Ez a terv hosszabb, mint amit az esemény az előkészítés és a szünetek után enged. Adjon indokot a használatához.',
  'error.training.planNotPublished': 'Eseményhez csak közzétett tervváltozat használható.',
  'error.training.notEditable': 'Közzétett változat nem módosítható. Indítson új változatot.',
  'error.assessment.codeTaken': 'Ez a protokollkulcs már használatban van a klubban.',
  'error.assessment.unknownDefinition': 'Ez a protokoll nem létezik.',
  'error.assessment.unknownDefinitionVersion':
    'Az alkalom egyik protokollja nem érhető el ennél a szakosztálynál.',
  'error.assessment.unknownAthlete': 'Az alkalom egyik sportolója nem ebben a szakosztályban edz.',
  'error.assessment.unknownEvent': 'A választott esemény nem a szakosztály felmérés-eseménye.',
  'error.assessment.unitMismatch':
    'A mértékegység nem egyezik a protokollal. Az értékeket csak a protokoll saját mértékegységében lehet rögzíteni.',
  'error.assessment.resultPublished':
    'Ez az eredmény közzé van téve. A módosításhoz indítson javítást.',
  'error.assessment.notCorrectable': 'Csak közzétett eredményt lehet javítani.',
  'error.assessment.draftExists':
    'Ennek az eredménynek már van közzé nem tett javítása. Előbb fejezze be vagy tegye közzé.',
  'error.assessment.noCorrection': 'Ennek az eredménynek nincs elvethető, közzé nem tett javítása.',
  'error.assessment.nothingToPublish': 'Nincs közzétehető piszkozat-eredmény.',
  'error.assessment.notAParticipant': 'Ez a sportoló vagy protokoll nem része az alkalomnak.',
  'error.assessment.definition.unitRequired':
    'Adja meg a mértékegységet, amelyben az értékeket mérik.',
  'error.assessment.definition.durationUnit': 'Az időtartamot mindig másodpercben kell rögzíteni.',
  'error.assessment.definition.boundsInvalid':
    'A legalacsonyabb érvényes érték számnak kell lennie, nem lehet nagyobb a legmagasabbnál, és legfeljebb annyi tizedesjegye lehet, mint a pontosságnak.',
  'error.assessment.definition.aggregationNotAllowed':
    'Az átlag csak számokra és időtartamokra használható.',
  'error.assessment.definition.rubricLevels':
    'Egy értékelési skálának 2–10 szintje lehet, mindegyik leírással.',
  'error.assessment.definition.notApplicable':
    'Ez a beállítás nem vonatkozik erre az értéktípusra.',
  'error.assessment.value.notANumber': 'Adjon meg egy számot.',
  'error.assessment.value.tooManyDecimals':
    'Ennek több tizedesjegye van, mint amennyit a protokoll megenged.',
  'error.assessment.value.negativeDuration': 'Az időtartam nem lehet negatív.',
  'error.assessment.value.belowMinimum': 'Ez a legalacsonyabb érvényes érték alatt van.',
  'error.assessment.value.aboveMaximum': 'Ez a legmagasabb érvényes érték felett van.',
  'error.assessment.value.notBoolean': 'Igent vagy nemet adjon meg.',
  'error.assessment.value.notRubricLevel': 'Válasszon a skála szintjei közül.',
  'error.assessment.value.required': 'Az érvényes kísérlethez érték kell; a nulla is érték.',
  'error.assessment.value.notAllowed':
    'Az érvénytelen vagy meg nem kísérelt próbának nincs értéke.',
  'error.assessment.value.tooManyAttempts': 'Ez a protokoll kevesebb kísérletet enged.',
  'error.assessment.value.noAttempts': 'Rögzítsen legalább egy kísérletet.',
  'error.assessment.selection.required': 'Válassza ki a számító kísérletet.',
  'error.assessment.selection.invalid': 'A kiválasztott kísérletnek érvényesnek kell lennie.',
  'error.assessment.selection.notAllowed':
    'Ez a protokoll automatikusan választja ki az eredményt; ne válasszon kísérletet.',
  'error.assessment.selection.reasonRequired': 'Indokolja, miért ezt a kísérletet választotta.',
  'error.assessment.selection.meanNotAllowed':
    'Az átlag csak számokra és időtartamokra használható.',
  'assessments.loading': 'Betöltés…',
  'assessments.saved': 'Mentve.',
  'assessments.protocols.title': 'Protokollok',
  'assessments.protocols.empty': 'Még nincs protokoll.',
  'assessments.protocols.add': 'Protokoll hozzáadása',
  'assessments.protocols.newVersion': 'Mentés új változatként',
  'assessments.protocols.edit': 'Szerkesztés új változatként',
  'assessments.protocols.cancel': 'Mégse',
  'assessments.protocol.version': 'Változat',
  'assessments.protocol.department': 'Elérhető számára',
  'assessments.protocol.wholeClub': 'Az egész klub',
  'assessments.protocol.code': 'Kulcs (kisbetűk, számjegyek és kötőjelek)',
  'assessments.protocol.title': 'Cím (az aktuális nyelven)',
  'assessments.protocol.instructions': 'Útmutató az edzőnek (nem kötelező)',
  'assessments.protocol.valueType': 'Az eredmény típusa',
  'assessments.protocol.unit': 'Mértékegység',
  'assessments.protocol.precision': 'Tizedesjegyek',
  'assessments.protocol.minimum': 'Legalacsonyabb érvényes érték',
  'assessments.protocol.maximum': 'Legmagasabb érvényes érték',
  'assessments.protocol.direction': 'Jobb, ha',
  'assessments.protocol.attempts': 'Engedélyezett kísérletek',
  'assessments.protocol.aggregation': 'Az eredmény',
  'assessments.protocol.allowOutOfRange':
    'A legalacsonyabb és legmagasabb értéken kívüli érték is elfogadható',
  'assessments.protocol.ratioScale': 'A százalékos változás értelmezhető ennél a protokollnál',
  'assessments.protocol.rubricLevel': 'A szint leírása',
  'assessments.protocol.addLevel': 'Szint hozzáadása',
  'assessments.protocol.removeLevel': 'Utolsó szint törlése',
  'assessments.protocol.distance': 'Távolság',
  'assessments.protocol.course': 'Pálya elrendezése',
  'assessments.protocol.surface': 'Felület',
  'assessments.protocol.method': 'Módszer',
  'assessments.protocol.contextHint':
    'A távolságot, a pályát, a felületet és a módszert minden eredmény megőrzi. Bármelyik változtatása új sorozatot indít a fejlődési grafikonokon.',
  'assessments.valueType.numeric': 'Szám',
  'assessments.valueType.duration': 'Időtartam (másodperc)',
  'assessments.valueType.boolean': 'Igen vagy nem',
  'assessments.valueType.rubric': 'Értékelési skála (szintek)',
  'assessments.direction.lower_is_better': 'Az alacsonyabb a jobb',
  'assessments.direction.higher_is_better': 'A magasabb a jobb',
  'assessments.aggregation.best': 'A legjobb kísérlet',
  'assessments.aggregation.mean': 'Az érvényes kísérletek átlaga',
  'assessments.aggregation.last': 'Az utolsó érvényes kísérlet',
  'assessments.aggregation.coach_selected': 'Az edző által választott kísérlet',
  'assessments.sessions.title': 'Felmérési alkalmak',
  'assessments.sessions.empty': 'Még nincs alkalom.',
  'assessments.session.new': 'Új alkalom',
  'assessments.session.date': 'Dátum',
  'assessments.session.context': 'Körülmények (nem kötelező, csak a stábnak)',
  'assessments.session.protocols': 'Használt protokollok',
  'assessments.session.athletes': 'Résztvevők',
  'assessments.session.search': 'Sportolók keresése',
  'assessments.session.loadMore': 'Továbbiak betöltése',
  'assessments.session.team': 'Csapat',
  'assessments.session.group': 'Edzéscsoport',
  'assessments.session.rosterChoice': 'Csapat vagy csoport hozzáadása',
  'assessments.session.addRoster': 'Játékosainak hozzáadása',
  'assessments.session.selected': 'kiválasztva',
  'assessments.session.create': 'Alkalom létrehozása',
  'assessments.session.open': 'Megnyitás',
  'assessments.session.close': 'Bezárás',
  'assessments.session.participants': 'résztvevő',
  'assessments.session.drafts': 'piszkozat',
  'assessments.session.published': 'közzétéve',
  'assessments.session.noProtocols': 'Előbb adjon hozzá egy protokollt.',
  'assessments.session.noAthletes': 'Nem található sportoló.',
  'assessments.entry.protocol': 'Protokoll',
  'assessments.entry.athlete': 'Sportoló',
  'assessments.entry.attempt': 'Kísérlet',
  'assessments.entry.invalid': 'Érvénytelen',
  'assessments.entry.blankHint':
    'Hagyja üresen a meg nem tett kísérletet. A nulla mért érték. Az elrontott kísérletet jelölje érvénytelennek.',
  'assessments.entry.yes': 'Igen',
  'assessments.entry.no': 'Nem',
  'assessments.entry.choose': 'Nincs rögzítve',
  'assessments.entry.level': 'Szint',
  'assessments.entry.counts': 'Számít',
  'assessments.entry.selectedAttempt': 'A számító kísérlet',
  'assessments.entry.reason': 'A választás indoka',
  'assessments.entry.privateNote': 'Privát megjegyzés (csak edzőknek)',
  'assessments.entry.publicComment': 'Megjegyzés a családnak (közzététel után látható)',
  'assessments.entry.save': 'Eredmények mentése',
  'assessments.entry.unsaved': 'Nem mentett módosítások',
  'assessments.entry.savedRows': 'sor mentve',
  'assessments.entry.conflict':
    'Egy másik edző előbb módosította ezt a sort. Az ő bejegyzése látható; nézze át, és szükség esetén mentse újra.',
  'assessments.entry.published': 'Közzétéve. A módosításhoz használja a Javítás gombot.',
  'assessments.entry.publish': 'Piszkozatok közzététele',
  'assessments.entry.publishDone': 'közzétéve',
  'assessments.entry.correct': 'Javítás',
  'assessments.entry.correctionReason': 'A javítás indoka',
  'assessments.entry.startCorrection': 'Javítás indítása',
  'assessments.entry.cancelCorrection': 'Mégse',
  'assessments.entry.correctionDraft':
    'Javítás van folyamatban. A családok a közzététel előtt továbbra is a közzétett eredményt látják.',
  'assessments.entry.discardCorrection': 'Javítás elvetése',
  'assessments.entry.draftState': 'Piszkozat',
  'assessments.entry.publishedState': 'Közzétéve',
  'assessments.entry.noResult': 'Még nincs eredmény',
  'assessments.status.valid': 'Érvényes',
  'assessments.status.invalid': 'Érvénytelen',
  'assessments.status.not_attempted': 'Nem kísérelte meg',
  'assessments.export.button': 'Eredmények exportálása',
  'assessments.export.column.familyName': 'Családnév',
  'assessments.export.column.givenName': 'Utónév',
  'assessments.export.column.protocol': 'Protokoll',
  'assessments.export.column.protocolVersion': 'Protokoll verziója',
  'assessments.export.column.unit': 'Mértékegység',
  'assessments.export.column.status': 'Állapot',
  'assessments.export.column.value': 'Eredmény',
  'assessments.export.column.revision': 'Változat',
  'assessments.export.column.publishedAt': 'Közzétéve',
  'assessments.export.column.comment': 'Megjegyzés a családnak',
  'assessments.aggregates.title': 'Csoportösszesítő (csak a stábnak)',
  'assessments.aggregates.count': 'Eredménnyel',
  'assessments.aggregates.suppressed':
    'Öt résztvevőnél kevesebbnek van eredménye, ezért nem jelenítünk meg számokat.',
  'assessments.aggregates.minimum': 'Legalacsonyabb',
  'assessments.aggregates.maximum': 'Legmagasabb',
  'assessments.aggregates.mean': 'Átlag',
  'assessments.progress.title': 'Fejlődés',
  'assessments.progress.athlete': 'Sportoló',
  'assessments.progress.choose': 'Válasszon sportolót',
  'assessments.progress.noAthletes': 'Nincs megjeleníthető sportoló.',
  'assessments.progress.empty': 'Még nincs közzétett eredmény.',
  'assessments.progress.date': 'Dátum',
  'assessments.progress.value': 'Eredmény',
  'assessments.progress.version': 'Protokollváltozat',
  'assessments.progress.comment': 'Megjegyzés',
  'assessments.progress.noValue': 'Nincs érvényes érték',
  'assessments.progress.change': 'Változás az első eredmény óta',
  'assessments.progress.absolute': 'Különbség',
  'assessments.progress.percent': 'Javulás',
  'assessments.progress.calculation':
    'Ez a mérési adatokról szóló számítás, nem a gyermek értékének vagy képességeinek megítélése.',
  'assessments.progress.absoluteOnly': 'Ennél a protokollnál csak a különbség értelmezhető.',
  'assessments.progress.gapNote':
    'A vonal megszakadása azt jelenti, hogy nem rögzítettek érvényes értéket; ez nem nulla. Az eredményeket csak azonos protokoll esetén kötjük össze.',
  'assessments.progress.table': 'Az eredmények táblázatban',
  'assessments.progress.chart': 'Az eredmények időbeli grafikonja',
  'assessments.progress.context': 'Rögzítés körülményei',
  'guardianLinks.adult.suspended':
    'A szülői hozzáférés szünetel, mert a sportoló betöltötte a 18. életévét:',
  'guardianLinks.adult.renew': 'Megújítás a sportoló engedélyével',
  'guardianLinks.adult.renewedOn': 'A hozzáférést a sportoló engedélyével megújították:',
  'guardianLinks.adult.title': '18 éves korba lépő sportolók',
  'guardianLinks.adult.intro':
    '18 évesen a szülő hozzáférése szünetel, amíg a sportoló nem engedélyezi. Hívja meg a sportolót saját fiókba, majd az egyes kapcsolatokat a beleegyezése után újítsa meg.',
  'guardianLinks.adult.on': '18 éves lesz:',
  'guardianLinks.adult.days': 'nap',
  'guardianLinks.adult.awaiting': 'Engedélyre váró kapcsolatok',
  'guardianLinks.adult.renewed': 'Megújítva',
  'guardianLinks.adult.hasAccount': 'Van fiókja',
  'guardianLinks.adult.invite': 'A sportoló meghívása',
  'guardianLinks.edit.open': 'Szerkesztés',
  'guardianLinks.edit.save': 'Módosítások mentése',
  'guardianLinks.edit.cancel': 'Mégse',
  'error.guardianLink.notAdult':
    'A sportoló még nem töltötte be a 18. életévét, így nincs mit engedélyezni.',
  'error.guardianLink.alreadyAuthorized':
    'Ezt a kapcsolatot már megújították a sportoló engedélyével.',
  'teams.rollover.title': 'A következő szezon megtervezése',
  'teams.rollover.intro':
    'Ez egy új, tervezet állapotú szezont hoz létre a megtartott csapatok és edzéscsoportok másolataival. A most megtekintett szezon és a keretei pontosan úgy maradnak, ahogy vannak.',
  'teams.rollover.open': 'A következő szezon megtervezése',
  'teams.rollover.submit': 'A következő szezon létrehozása',
  'teams.rollover.cancel': 'Mégse',
  'teams.rollover.members': 'Aktív tagok',
  'teams.rollover.carryOver':
    'A ma aktív sportolókat az új szezon kezdetétől az új csapatokba és csoportokba is beosztom',
  'teams.rollover.done': 'Létrehozva',
  'teams.rollover.teamsCreated': 'csapat',
  'teams.rollover.groupsCreated': 'csoport',
  'teams.rollover.placementsCreated': 'beosztás',
  'athletes.status.archive': 'Sportoló archiválása',
  'athletes.status.withdraw': 'Kilépés rögzítése',
  'athletes.status.reactivate': 'Sportoló újraaktiválása',
  'athletes.status.reason': 'Indok',
  'athletes.status.hint.archive':
    'Az archiválás ma lezárja a sportoló nyitott klubtagságát, valamint csapat- és csoportbeosztásait. Minden előzményként megmarad.',
  'athletes.status.hint.withdraw':
    'A kilépés rögzítése ugyanezt teszi, és ma után a szülők hozzáférését is megszünteti ehhez a sportolóhoz. Minden előzményként megmarad.',
  'athletes.status.done': 'Az állapot módosítva.',
  'athletes.status.ended.memberships': 'Lezárt tagságok',
  'athletes.status.ended.teams': 'Lezárt csapatbeosztások',
  'athletes.status.ended.groups': 'Lezárt csoportbeosztások',
  'athletes.status.ended.links': 'Lezárt szülői kapcsolatok',
  'error.athlete.statusUnchanged': 'A sportoló már ebben az állapotban van.',
  'payments.title': 'Az Ön pénzügyi fiókjai',
  'payments.note': 'Minden fiók külön jelenik meg. A különböző fiókok összegeit sosem adjuk össze.',
  'payments.loading': 'A fiókok betöltése…',
  'payments.empty': 'A klub még nem osztott meg Önnel egyetlen pénzügyi fiókot sem.',
  'payments.statement.show': 'Kivonat megjelenítése',
  'payments.statement.hide': 'Kivonat elrejtése',
  'billing.accounts.title': 'Számlázási fiókok',
  'billing.accounts.loading': 'Számlázási fiókok betöltése…',
  'billing.accounts.empty': 'Még nincs számlázási fiók.',
  'billing.accounts.loadMore': 'További fiókok betöltése',
  'billing.accounts.create.label': 'Fiók neve',
  'billing.accounts.create.submit': 'Fiók létrehozása',
  'billing.accounts.open': 'Fiók megnyitása',
  'billing.accounts.closed': 'Lezárva',
  'billing.back': 'Vissza a fiókokhoz',
  'billing.detail.loading': 'A fiók betöltése…',
  'billing.position.balance': 'Egyenleg',
  'billing.position.overdue': 'Lejárt',
  'billing.position.upcoming': 'Közelgő',
  'billing.position.credit': 'Le nem képzett jóváírás',
  'billing.fees.plans.title': 'Díjcsomagok',
  'billing.fees.plans.empty': 'Még nincs díjcsomag.',
  'billing.fees.plans.create.title': 'Új díjcsomag',
  'billing.fees.plans.create.titleVersion': 'A kiválasztott díjcsomag új verziója',
  'billing.fees.plan.name.en': 'Név (angol)',
  'billing.fees.plan.name.hu': 'Név (magyar, nem kötelező)',
  'billing.fees.plan.name.ro': 'Név (román, nem kötelező)',
  'billing.fees.plan.amount': 'Havi összeg',
  'billing.fees.plan.currency': 'Pénznem',
  'billing.fees.plan.dueDay': 'A hónap esedékességi napja',
  'billing.fees.plan.dueDayHelp': 'A hónap végén túli nap a hónap utolsó napjára esik.',
  'billing.fees.plan.effectiveFrom': 'Hatályos ettől',
  'billing.fees.plan.effectiveTo': 'Hatályos eddig (nem kötelező)',
  'billing.fees.plan.version': 'Verzió',
  'billing.fees.plan.newVersion': 'Új verzió',
  'billing.fees.plan.startNew': 'Inkább új díjcsomag indítása',
  'billing.fees.plan.submit': 'Díjcsomag mentése',
  'billing.fees.plan.saved': 'A díjcsomag mentve.',
  'billing.fees.plan.invalid': 'Ellenőrizze az összeget, az esedékességi napot és a dátumokat.',
  'billing.fees.run.title': 'Havi díjfuttatás',
  'billing.fees.run.month': 'Hónap',
  'billing.fees.run.preview': 'Futtatás előnézete',
  'billing.fees.run.invalidMonth': 'Válasszon hónapot.',
  'billing.fees.run.empty': 'Ezt a hónapot nem érinti díjhozzárendelés.',
  'billing.fees.run.count.generate': 'Könyvelésre kerül',
  'billing.fees.run.count.review': 'Felülvizsgálat szükséges',
  'billing.fees.run.count.billed': 'Már kiszámlázva',
  'billing.fees.run.count.skipped': 'Kihagyva',
  'billing.fees.run.total': 'Könyvelendő összeg',
  'billing.fees.run.col.athlete': 'Sportoló',
  'billing.fees.run.col.account': 'Fiók',
  'billing.fees.run.col.plan': 'Díjcsomag',
  'billing.fees.run.col.amount': 'Összeg',
  'billing.fees.run.col.due': 'Esedékes',
  'billing.fees.run.col.status': 'Állapot',
  'billing.fees.run.outcome.generate': 'Könyvelésre kerül',
  'billing.fees.run.outcome.review': 'Felülvizsgálat szükséges',
  'billing.fees.run.outcome.billed': 'Már kiszámlázva',
  'billing.fees.run.outcome.skip': 'Kihagyva',
  'billing.fees.run.skip.notStarted': 'Még nem kezdődött el',
  'billing.fees.run.skip.ended': 'Lezárult',
  'billing.fees.run.skip.paused': 'Szünetel',
  'billing.fees.run.skip.planNotEffective': 'A díjcsomag nem hatályos',
  'billing.fees.run.skip.fullyWaived': 'Teljes kedvezmény',
  'billing.fees.run.skip.accountClosed': 'A fiók le van zárva',
  'billing.fees.run.skip.periodClosed': 'A beszámolási időszak lezárt',
  'billing.fees.run.review.amount': 'Felülvizsgált összeg',
  'billing.fees.run.review.help':
    'Ezek a sportolók hónap közben kezdenek. Adja meg az első hónapra terhelendő összeget; ha üresen hagyja, egyelőre nem készül tétel.',
  'billing.fees.run.review.invalid': 'Adjon meg érvényes összeget.',
  'billing.fees.run.commit': 'Futtatás könyvelése',
  'billing.fees.run.committed': 'A futtatás könyvelve.',
  'billing.fees.run.result.created': 'Új tételek',
  'billing.fees.run.result.billed': 'Már kiszámlázva',
  'billing.fees.run.result.review': 'Felülvizsgálatra vár',
  'billing.fees.run.result.skipped': 'Kihagyva',
  'billing.fees.auto.title': 'Automatikus havi futtatás',
  'billing.fees.auto.description':
    'Bekapcsolva a rendszer magától könyveli az aktuális hónap díjtételeit a klub saját naptára szerint. Pontosan azt könyveli, amit az előnézet „Könyvelésre kerül” címkével mutat; a hónap közben kezdődő hozzárendelések az Ön felülvizsgálatára várnak, a már kiszámlázott hónapot pedig sosem számlázza ki újra.',
  'billing.fees.auto.on': 'Az automatikus futtatás be van kapcsolva',
  'billing.fees.auto.off': 'Az automatikus futtatás ki van kapcsolva',
  'billing.fees.auto.enable': 'Bekapcsolás',
  'billing.fees.auto.disable': 'Kikapcsolás',
  'billing.fees.auto.confirm':
    'Előbb nézze meg az aktuális hónap előnézetét. Bekapcsolás után a rendszer perceken belül könyvelheti az e havi tételeket. Bekapcsolja az automatikus futtatást?',
  'billing.fees.auto.confirmEnable': 'Igen, bekapcsolom',
  'billing.fees.auto.cancel': 'Mégse',
  'billing.fees.auto.noRun': 'Még nem volt automatikus futtatás.',
  'billing.fees.auto.lastRun': 'Utolsó automatikus futtatás',
  'billing.fees.auto.succeeded': 'Sikeres',
  'billing.fees.auto.failed': 'Sikertelen, automatikusan újra próbálkozik',
  'billing.fees.assign.title': 'A fiók havi díjtervei',
  'billing.fees.assign.empty':
    'Ehhez a fiókhoz nincs havi díjterv rendelve. Az éves tagdíj a fenti, külön részben látható.',
  'billing.fees.assign.noPlans':
    'A klubnak nincs havi díjterve. Csak akkor kell, ha havonta szeretne díjat terhelni; a Pénzügyek oldal „Díjtervek és havi díjak” részében hozhatja létre.',
  'billing.fees.assign.athlete': 'Sportoló',
  'billing.fees.assign.plan': 'Díjcsomag',
  'billing.fees.assign.startsOn': 'Kezdete',
  'billing.fees.assign.submit': 'Díj hozzárendelése',
  'billing.fees.assign.end': 'Lezárás',
  'billing.fees.assign.pause': 'Szüneteltetés',
  'billing.fees.assign.resume': 'Folytatás',
  'billing.fees.assign.pausedFrom': 'Szünet kezdete',
  'billing.fees.assign.pausedUntil': 'Szünet vége (nem kötelező)',
  'billing.fees.assign.pausedBadge': 'Szünetel',
  'billing.fees.concession.label': 'Kedvezmény',
  'billing.fees.concession.none': 'Nincs',
  'billing.fees.concession.amount': 'Fix összegű kedvezmény',
  'billing.fees.concession.percent': 'Százalékos kedvezmény',
  'billing.fees.concession.amountValue': 'Kedvezmény összege',
  'billing.fees.concession.percentValue': 'Kedvezmény (%)',
  'billing.fees.concession.reason': 'A jóváhagyás indoka',
  'billing.fees.concession.invalid': 'Adjon meg érvényes értéket és indoklást.',
  'billing.assignments.title': 'A fiókhoz rendelt sportolók',
  'billing.assignments.empty': 'Ehhez a fiókhoz nincs sportoló rendelve.',
  'billing.assignments.athleteSearch': 'Sportoló keresése',
  'billing.assignments.noMatches': 'Nincs találat.',
  'billing.assignments.assign': 'Sportoló hozzárendelése',
  'billing.assignments.end': 'Hozzárendelés lezárása',
  'billing.assignments.until': '-ig',
  'billing.access.title': 'A fiókhoz hozzáféréssel rendelkező személyek',
  'billing.access.empty': 'Ehhez a fiókhoz senki sincs jóváhagyva.',
  'billing.access.personSearch': 'Személy keresése',
  'billing.access.noMatches': 'Nincs találat.',
  'billing.access.permission': 'Jogosultság',
  'billing.access.permission.view': 'Egyenleg és kivonat megtekintése',
  'billing.access.permission.manage': 'Kezelés',
  'billing.access.from': 'érvényes:',
  'billing.access.validFrom': 'Érvényes ettől',
  'billing.access.validUntil': 'Érvényes eddig (nem kötelező)',
  'billing.access.grant': 'Személy jóváhagyása',
  'billing.access.revoke': 'Hozzáférés visszavonása',
  'billing.access.revoked': 'Visszavonva',
  'billing.charges.title': 'Tételek',
  'billing.charges.empty': 'Még nincs tétel.',
  'billing.charges.post.title': 'Tétel könyvelése',
  'billing.charges.post.description': 'Leírás',
  'billing.charges.post.amount': 'Összeg',
  'billing.charges.post.dueOn': 'Esedékesség',
  'billing.charges.post.submit': 'Tétel könyvelése',
  'billing.charge.open': 'Nyitott',
  'billing.charge.paid': 'Rendezve',
  'billing.charge.reversed': 'Sztornózva',
  'billing.charge.creditNote': 'Jóváíró számla',
  'billing.charge.reverse': 'Tétel sztornózása',
  'billing.kind.fee': 'Tagdíj',
  'billing.kind.manual': 'Kézi',
  'billing.kind.opening': 'Nyitóegyenleg',
  'billing.col.description': 'Leírás',
  'billing.col.dueOn': 'Esedékes',
  'billing.col.amount': 'Összeg',
  'billing.col.outstanding': 'Fennálló',
  'billing.col.status': 'Állapot',
  'billing.col.date': 'Dátum',
  'billing.col.method': 'Mód',
  'billing.col.reference': 'Hivatkozás',
  'billing.col.available': 'Elérhető',
  'billing.col.type': 'Típus',
  'billing.col.effectiveOn': 'Hatályos',
  'billing.col.change': 'Változás',
  'billing.col.balance': 'Egyenleg',
  'billing.statement.title': 'Kivonat',
  'billing.statement.asOf': 'Kivonat napja',
  'billing.statement.loading': 'A kivonat betöltése…',
  'billing.statement.empty': 'Erre a napra bezárólag nincs rögzített tétel ezen a fiókon.',
  'billing.statement.opening': 'Áthozott egyenleg',
  'billing.statement.closing': 'Egyenleg ezen a napon',
  'billing.statement.truncated': 'A régebbi tételek az áthozott egyenlegben szerepelnek.',
  'billing.statement.note':
    'A tételek a rögzítésük pillanatától számítanak. A pozitív változás növeli a tartozást, a negatív csökkenti. A lejárt, a közelgő és a le nem képzett jóváírás a kiválasztott napon fennálló állapotot mutatja.',
  'billing.statement.openCharges': 'Ezen a napon még fizetendő tételek',
  'billing.statement.kind.charge': 'Tétel',
  'billing.statement.kind.creditNote': 'Jóváíró számla',
  'billing.statement.kind.payment': 'Befizetés',
  'billing.statement.kind.paymentReversal': 'Befizetés sztornózva',
  'billing.statement.kind.refund': 'Visszatérítés',
  'billing.periods.title': 'Lezárt időszakok',
  'billing.periods.note':
    'Az időszak lezárása egy napig zárolja a főkönyvet: utána sem kézzel, sem a díjgenerálással nem rögzíthető olyan tétel, amelynek esedékessége vagy befizetési napja a lezárt napon vagy előtte van. A lezárás nem vonható vissza. A későbbi helyesbítések jóváíró számlaként, sztornóként vagy visszatérítésként a nyitott időszakban kerülnek rögzítésre.',
  'billing.periods.closedThrough': 'Lezárva eddig',
  'billing.periods.none': 'Még nincs lezárt időszak.',
  'billing.periods.field.closedThrough': 'Lezárás napja (beleértve)',
  'billing.periods.field.note': 'Indoklás vagy megjegyzés',
  'billing.periods.field.confirm': 'Tudomásul veszem, hogy ez nem vonható vissza',
  'billing.periods.submit': 'Időszak lezárása',
  'billing.periods.done': 'Az időszak le lett zárva.',
  'billing.periods.history': 'Korábbi lezárások',
  'billing.periods.closedAt': 'Lezárás ideje',
  'billing.reports.title': 'Jelentések',
  'billing.reports.note':
    'A teljes klub összesítése úgy, ahogyan a főkönyv a kiválasztott nap végén állt, pénznemenként egy blokkban; a különböző pénznemeket sosem adjuk össze. Lejárt az az összeg, amely a nap előtt esedékes tételekből még fennáll. A tételeket abba a csapatba soroljuk, amelyben a sportoló a tétel esedékességének napján volt, a befizetéseket fizetési mód szerint.',
  'billing.reports.asOf': 'Jelentés napja',
  'billing.reports.asOfHelp': 'Üresen hagyva: ma.',
  'billing.reports.season': 'Szezon',
  'billing.reports.team': 'Csapat az esedékesség napján',
  'billing.reports.method': 'Fizetési mód',
  'billing.reports.account': 'Fiók',
  'billing.reports.any': 'Mind',
  'billing.reports.loading': 'A jelentés betöltése…',
  'billing.reports.empty': 'Ehhez a kijelöléshez nincs számlázási fiók.',
  'billing.reports.accounts': 'Fiókok',
  'billing.reports.generatedAt': 'Készült',
  'billing.reports.currency': 'Pénznem',
  'billing.reports.byTeam': 'Tételek csapat szerint az esedékesség napján',
  'billing.reports.byMethod': 'Befizetések fizetési mód szerint',
  'billing.reports.noTeam': 'Nem volt csapata az esedékesség napján',
  'billing.reports.total': 'Összesen',
  'billing.reports.col.team': 'Csapat',
  'billing.reports.col.method': 'Mód',
  'billing.reports.col.count': 'Bejegyzés',
  'billing.reports.col.charged': 'Terhelt',
  'billing.reports.col.credited': 'Jóváírások',
  'billing.reports.col.allocated': 'Lekötve',
  'billing.reports.col.received': 'Beérkezett',
  'billing.reports.col.reversed': 'Visszavonva',
  'billing.reports.col.refunded': 'Visszatérítve',
  'billing.reports.chargesOmitted':
    'A tételek nem jelennek meg, amíg fizetési mód van kiválasztva, mert a tételnek nincs fizetési módja.',
  'billing.reports.paymentsOmitted':
    'A befizetések nem jelennek meg, amíg csapat van kiválasztva, mert a befizetés egy fiókhoz tartozik, nem csapathoz.',
  'billing.reports.reconciliation.title': 'Egyeztetés',
  'billing.reports.reconciliation.note':
    'Ugyanazon főkönyv tétel-, befizetés-, lekötés-, visszatérítés- és kivonatnézetét veti össze. A kiválasztott fiókok minden bejegyzését tartalmazza erre a napig, bármelyik szezon, csapat vagy fizetési mód van is kiválasztva.',
  'billing.reports.reconciliation.check': 'Ellenőrzés',
  'billing.reports.reconciliation.expected': 'Várt',
  'billing.reports.reconciliation.actual': 'Talált',
  'billing.reports.reconciliation.result': 'Eredmény',
  'billing.reports.reconciliation.ok': 'Egyezik',
  'billing.reports.reconciliation.mismatch': 'Eltér',
  'billing.reports.check.balance':
    'A tételekből és befizetésekből számolt egyenleg egyenlő a kivonat bejegyzéseinek összegével',
  'billing.reports.check.settle':
    'A tételeken fennálló tartozás egyenlő a fennálló összeggel (egy tétel sincs az összegén túl rendezve)',
  'billing.reports.check.allocations':
    'A tételek felől látott lekötések egyenlők a befizetések felől látott lekötésekkel',
  'billing.reports.check.payments':
    'A megtartott befizetések egyenlők a lekötött, a visszatérített és a le nem képzett jóváírás összegével',
  'billing.reports.export': 'CSV letöltése',
  'billing.reason': 'Indoklás',
  'billing.confirm': 'Megerősítés',
  'billing.cancel': 'Mégse',
  'billing.creditNote.amount': 'Jóváírás összege',
  'billing.creditNote.submit': 'Jóváíró könyvelése',
  'billing.reverse.submit': 'Sztornó',
  'billing.refund.amount': 'Visszatérítés összege',
  'billing.refund.submit': 'Visszatérítés könyvelése',
  'billing.payments.title': 'Befizetések',
  'billing.payments.empty': 'Még nincs befizetés.',
  'billing.payment.post.title': 'Befizetés rögzítése',
  'billing.payment.amount': 'Beérkezett összeg',
  'billing.payment.paidOn': 'Beérkezés napja',
  'billing.payment.method': 'Mód',
  'billing.payment.reference': 'Bizonylat vagy banki hivatkozás',
  'billing.payment.payerReference': 'Fizető (nem kötelező)',
  'billing.payment.preview': 'Képzés előnézete',
  'billing.payment.allocation.title':
    'Képzés a legrégebbi esedékesség szerint. Szükség esetén módosítsa az összegeket.',
  'billing.payment.allocation.none':
    'A fiókon nincs nyitott tétel. A teljes összeg le nem képzett jóváírásként marad.',
  'billing.payment.allocation.invalidAmount':
    'Minden képzett összeget pozitív számként, legfeljebb két tizedessel adjon meg, vagy hagyja üresen.',
  'billing.payment.allocation.exceedsPayment':
    'A képzett összegek együtt meghaladják a befizetést.',
  'billing.payment.allocation.total': 'Képezve',
  'billing.payment.allocation.unallocated': 'Le nem képzett jóváírásként marad',
  'billing.payment.submit': 'Befizetés rögzítése',
  'billing.payment.reversed': 'Sztornózva',
  'billing.payment.refunded': 'Visszatérítve',
  'billing.payment.reverse': 'Befizetés sztornózása',
  'billing.payment.refund': 'Visszatérítés',
  'billing.payment.allocate': 'Jóváírás képzése',
  'billing.payment.allocate.submit': 'Képzés',
  'billing.payment.allocate.nothingOpen':
    'A fiókon nincs nyitott tétel, amelyre a jóváírás képezhető lenne.',
  'billing.method.cash': 'Készpénz',
  'billing.method.bankTransfer': 'Banki átutalás',
  'billing.method.cardTerminal': 'Kártyaterminál',
  'billing.method.openingBalance': 'Nyitóegyenleg',
  'billing.method.other': 'Egyéb',
  'billing.invalidAmount': 'Pozitív összeget adjon meg legfeljebb két tizedessel, például 200,50.',
  'billing.posted': 'Könyvelve.',
  'teams.category.U7': 'U7',
  'teams.category.U9': 'U9',
  'teams.category.WOMEN': 'Női',
  'teams.category.GIRLS_3X3_CUP': 'Lány 3x3 Kupa',
  'competitions.seasons.title': 'Versenyszezonok',
  'competitions.seasons.empty': 'Még nincs létrehozott versenyszezon.',
  'competitions.seasons.create.title': 'Új versenyszezon',
  'competitions.seasons.submit': 'Versenyszezon létrehozása',
  'competitions.seasons.done': 'A versenyszezon létrejött.',
  'competitions.field.season': 'Szezon',
  'competitions.field.name': 'Név',
  'competitions.field.federation': 'Szövetség',
  'competitions.field.category': 'Kategória',
  'competitions.field.division': 'Osztály (nem kötelező)',
  'competitions.field.format': 'Formátum (nem kötelező)',
  'competitions.field.phases': 'Szakaszok',
  'competitions.phase.regular': 'Alapszakasz',
  'competitions.phase.playoff': 'Rájátszás',
  'competitions.phase.tournament': 'Torna',
  'competitions.rules.none':
    'Nincs aktív szabályverzió: a szabályosság „felülvizsgálatra vár” marad.',
  'competitions.rules.active': 'Aktív szabályverzió',
  'competitions.profiles.title': 'Szabályprofil-verziók',
  'competitions.profiles.empty':
    'Ehhez a versenyhez még nincs szabályprofil. Amíg egyet nem aktiválnak, minden szabályossági eredmény „felülvizsgálatra vár”.',
  'competitions.profiles.catalogField': 'Piszkozat indítása ebből',
  'competitions.profiles.createDraft': 'Piszkozat létrehozása',
  'competitions.profiles.draftCreated': 'A piszkozat létrejött.',
  'competitions.profile.version': 'Verzió',
  'competitions.profile.status.draft': 'Piszkozat',
  'competitions.profile.status.active': 'Aktív',
  'competitions.profile.status.superseded': 'Felváltva',
  'competitions.profile.validity': 'Érvényes',
  'competitions.profile.counts':
    'források: {sources}, rögzített hash: {hashes}, feltételek: {conditions}, kézi ellenőrzések: {manual}',
  'competitions.profile.checkedOn': 'A forrásokat ellenőrizték',
  'competitions.profile.activatedOn': 'Aktiválva',
  'competitions.profile.draftNote':
    'A piszkozat soha nem hagy jóvá senkit. Rögzítse a forrásdokumentumok ellenőrzését, majd aktiválja.',
  'competitions.profile.manualChecks':
    'Kötelező kézi ellenőrzések (nincsenek kódolva; nyitva maradnak, és akadályozzák a hivatalos használatra kész exportot)',
  'competitions.verify.title': 'A forrásellenőrzés rögzítése',
  'competitions.verify.hashField': 'Forrás SHA-256 értéke:',
  'competitions.verify.checkedOn': 'Az ellenőrzés napja',
  'competitions.verify.note': 'Mit ellenőrzött (módosítások, a klub versenye)',
  'competitions.verify.submit': 'Forrásellenőrzés rögzítése',
  'competitions.verify.done': 'A forrásellenőrzés rögzítve.',
  'competitions.verify.problem.hash': 'A hash 64 hexadecimális karakterből áll.',
  'competitions.verify.problem.date': 'Adjon meg érvényes dátumot.',
  'competitions.verify.problem.future': 'Az ellenőrzés napja nem lehet jövőbeli.',
  'competitions.verify.problem.note': 'Írja le, mit ellenőrzött.',
  'competitions.activate.title': 'A verzió aktiválása',
  'competitions.activate.note': 'Az aktiválás oka',
  'competitions.activate.confirm':
    'Ellenőriztem a pontos forrásdokumentumokat és a klub versenyét ezzel a verzióval szemben.',
  'competitions.activate.submit': 'Verzió aktiválása',
  'competitions.activate.done': 'A verzió aktív. Az előző aktív verziót felváltotta.',
  'competitions.blocker.no_sources':
    'A profil nem nevez meg forrást, így nincs mit ellenőrizni, és nem aktiválható.',
  'competitions.blocker.source_hash_missing': 'Rögzítse minden forrásdokumentum SHA-256 értékét.',
  'competitions.blocker.sources_not_checked':
    'Rögzítse, mikor ellenőrizte a forrásokat módosítások szempontjából.',
  'competitions.blocker.category_mismatch': 'A profil kategóriája eltér a verseny kategóriájától.',
  'error.competition.invalidTimeZone': 'Ez nem ismert időzóna.',
  'error.competition.seasonClosed': 'A szezon lezárt, nem adható hozzá verseny.',
  'error.ruleProfile.unknownCatalogKey': 'Ez a piszkozat nincs a katalógusban.',
  'error.ruleProfile.categoryMismatch': 'A piszkozat másik kategóriához tartozik, mint a verseny.',
  'error.ruleProfile.draftExists':
    'Ennek a versenynek már van piszkozata; először ellenőrizze és aktiválja.',
  'error.ruleProfile.notDraft': 'Csak piszkozat módosítható.',
  'error.ruleProfile.unknownSource':
    'Olyan forráshoz adott meg hash-t, amelyet a profil nem nevez meg.',
  'error.ruleProfile.checkedInFuture': 'Az ellenőrzés napja nem lehet jövőbeli.',
  'error.ruleProfile.notReady':
    'Aktiválás előtt rögzítse minden forrás hash-ét és az ellenőrzés napját.',
  'registrations.title': 'Regisztrációk',
  'registrations.loading': 'Regisztrációk betöltése…',
  'registrations.empty': 'Ebbe a versenybe még nincs sportoló regisztrálva.',
  'registrations.openEnded': 'nincs utolsó nap',
  'registrations.license': 'Licenchivatkozás',
  'registrations.endedReason': 'A lezárás oka',
  'registrations.mode.native': 'Saját',
  'registrations.mode.temporary_play_up': 'Ideiglenes feljátszás',
  'registrations.mode.exclusive_higher': 'Kizárólag magasabb korosztály',
  'registrations.mode.hint':
    'Saját: a sportoló a saját korosztályában játszik. Ideiglenes feljátszás: a sportoló korlátozott ideig játszik feljebb. Kizárólag magasabb: a sportoló csak a magasabb korosztályra van regisztrálva.',
  'registrations.status.active': 'Aktív',
  'registrations.status.ended': 'Lezárt',
  'registrations.create.title': 'Sportoló regisztrálása',
  'registrations.field.athlete': 'Sportoló (írjon be egy nevet)',
  'registrations.field.team': 'Csapat',
  'registrations.field.mode': 'Regisztráció módja',
  'registrations.field.validFrom': 'Első nap',
  'registrations.field.validTo': 'Utolsó nap (nem kötelező)',
  'registrations.field.license': 'Licenchivatkozás (nem kötelező)',
  'registrations.field.classification': 'Versenybesorolás',
  'registrations.classification.hint':
    'Csak amit a verseny szabályai megkövetelnek: lány a lányokra vonatkozó születési időszakhoz, női válogatott a versenybizottság jóváhagyását igénylő játékosokhoz, általános mindenki máshoz.',
  'registrations.classification.general': 'Általános',
  'registrations.classification.girls': 'Lány',
  'registrations.classification.national_team_female': 'Női válogatott játékos',
  'registrations.noAthletes': 'Nincs találat',
  'registrations.noTeams':
    'A verseny osztályának ebben a szezonban még nincs csapata. Előbb hozzon létre egyet a Csapatok oldalon.',
  'registrations.submit': 'Sportoló regisztrálása',
  'registrations.done': 'A sportoló regisztrálva.',
  'registrations.correct': 'Javítás',
  'registrations.correct.submit': 'Javítás mentése',
  'registrations.correct.done': 'A regisztráció javítva.',
  'registrations.end': 'Regisztráció lezárása',
  'registrations.end.hint':
    'A regisztráció előzményként megmarad. A sportoló újbóli regisztrálásához hozzon létre új regisztrációt.',
  'registrations.end.day': 'A regisztráció utolsó napja',
  'registrations.end.reason': 'A lezárás oka',
  'registrations.end.submit': 'Regisztráció lezárása',
  'registrations.end.done': 'A regisztráció lezárva.',
  'registrations.cancel': 'Mégse',
  'error.registration.overlap':
    'Ennek a sportolónak ezeken a napokon már van aktív regisztrációja ebben a versenyben.',
  'error.registration.athleteNotActive': 'Csak aktív sportoló regisztrálható.',
  'error.registration.teamMismatch':
    'Válasszon aktív csapatot a verseny osztályából és szezonjából.',
  'error.registration.notActive': 'Ez a regisztráció lezárult, és már nem módosítható.',
  'error.registration.invalidEnd':
    'Az utolsó nap nem lehet az első nap előtt, a jövőben vagy a tervezett utolsó nap után.',
  'error.registration.invalidValidTo': 'Az utolsó nap nem lehet az első nap előtt.',
  'evidence.title': 'Igazoló dokumentumok',
  'evidence.hint':
    'Rögzítsd, hogy egy sportolóhoz létezik egy dokumentum, ki állította ki és mely napokon érvényes, majd hagyd jóvá vagy utasítsd el. Csak a jóváhagyott igazolás számít a szabályosság megállapításakor. A dokumentum másolatát itt nem tároljuk.',
  'evidence.loading': 'Igazolások betöltése…',
  'evidence.empty': 'Ennek a versenynek a sportolóihoz még nincs rögzítve igazolás.',
  'evidence.openEnded': 'nincs utolsó nap',
  'evidence.issuer': 'Kiállító',
  'evidence.reference': 'Hivatkozás',
  'evidence.decisionNote': 'A döntés megjegyzése',
  'evidence.type.medical_clearance': 'Orvosi alkalmassági igazolás',
  'evidence.type.under_18_agreement': 'Megállapodás 18 év alatti sportolóhoz',
  'evidence.type.promotion_agreement': 'Feljátszási megállapodás',
  'evidence.type.loan_agreement': 'Kölcsönadási megállapodás',
  'evidence.type.transfer_approval': 'Átigazolási jóváhagyás',
  'evidence.status.pending': 'Döntésre vár',
  'evidence.status.verified': 'Jóváhagyva',
  'evidence.status.rejected': 'Elutasítva',
  'evidence.create.title': 'Igazolás rögzítése',
  'evidence.field.athlete': 'Sportoló (írj be egy nevet)',
  'evidence.field.type': 'Dokumentum típusa',
  'evidence.field.issuer': 'Kiállító (nem kötelező)',
  'evidence.field.reference': 'Hivatkozás (nem kötelező)',
  'evidence.field.validFrom': 'Érvényesség első napja',
  'evidence.field.validTo': 'Érvényesség utolsó napja (nem kötelező)',
  'evidence.noAthletes': 'Nincs ilyen sportoló',
  'evidence.submit': 'Igazolás rögzítése',
  'evidence.done': 'Az igazolás rögzítve. A jóváhagyás után számít.',
  'evidence.correct': 'Javítás',
  'evidence.correct.submit': 'Javítás mentése',
  'evidence.correct.done': 'Az igazolás javítva.',
  'evidence.verify': 'Jóváhagyás',
  'evidence.verify.hint':
    'Erősítsd meg, hogy láttad a dokumentumot, és az adatok egyeznek. A jóváhagyott rekord már nem javítható, csak visszavonható.',
  'evidence.verify.note': 'Megjegyzés (nem kötelező, egészségügyi részleteket ne írj)',
  'evidence.verify.submit': 'Igazolás jóváhagyása',
  'evidence.verify.done': 'Az igazolás jóváhagyva.',
  'evidence.reject': 'Elutasítás',
  'evidence.withdraw': 'Visszavonás',
  'evidence.reject.hint':
    'A rekord előzményként megmarad, és többé nem változtatható. Ha létezik érvényes dokumentum, rögzítsd új igazolásként.',
  'evidence.reject.reason': 'Indok (egészségügyi részleteket ne írj)',
  'evidence.reject.submit': 'Megerősítés',
  'evidence.reject.done': 'Az igazolás elutasítva.',
  'evidence.cancel': 'Mégse',
  'error.evidence.wrongState':
    'Erről az igazolásról már döntöttek, vagy visszavonták, ezért így nem módosítható.',
  'error.evidence.invalidInterval': 'Az érvényesség utolsó napja nem lehet az első napja előtt.',
  'suspension.title': 'Eltiltások',
  'suspension.hint':
    'Rögzítsd, hogy egy sportoló nem játszhat egy utolsó napig vagy meghatározott számú mérkőzésig. Csak az érvényben lévő eltiltás számít a szabályossághoz; a letöltött vagy visszavont előzményként megmarad.',
  'suspension.loading': 'Eltiltások betöltése…',
  'suspension.empty': 'Erre a versenyre nem vonatkozik eltiltás.',
  'suspension.until': 'eddig:',
  'suspension.gamesLeft': 'hátralévő mérkőzés',
  'suspension.everyCompetition': 'a klub minden versenye',
  'suspension.reference': 'Döntésszám',
  'suspension.closingNote': 'Megjegyzés a lezáráshoz',
  'suspension.status.active': 'Érvényben',
  'suspension.status.served': 'Letöltve',
  'suspension.status.revoked': 'Visszavonva',
  'suspension.create.title': 'Eltiltás rögzítése',
  'suspension.field.athlete': 'Sportoló (írj be egy nevet)',
  'suspension.field.scope': 'Hatálya',
  'suspension.field.measure': 'Számolás módja',
  'suspension.measure.games': 'Mérkőzések',
  'suspension.measure.days': 'Napok (utolsó napig)',
  'suspension.field.startsOn': 'Első nap',
  'suspension.field.endsOn': 'Utolsó nap',
  'suspension.field.games': 'Hátralévő mérkőzések',
  'suspension.field.gamesHint': 'Egész szám 0 és {maximum} között.',
  'suspension.field.reference': 'Döntésszám (nem kötelező)',
  'suspension.noAthletes': 'Nincs ilyen sportoló',
  'suspension.submit': 'Eltiltás rögzítése',
  'suspension.done': 'Az eltiltás rögzítve. Amíg érvényben van, számít.',
  'suspension.correct': 'Javítás',
  'suspension.correct.submit': 'Javítás mentése',
  'suspension.correct.done': 'Az eltiltás javítva.',
  'suspension.serve': 'Letöltöttnek jelöl',
  'suspension.serve.hint':
    'Erősítsd meg, hogy az eltiltást letöltötte. Előzményként megmarad, és többé nem számít.',
  'suspension.serve.note': 'Megjegyzés (nem kötelező)',
  'suspension.serve.submit': 'Letöltöttnek jelöl',
  'suspension.serve.done': 'Az eltiltás letöltöttként megjelölve.',
  'suspension.revoke': 'Visszavonás',
  'suspension.revoke.hint':
    'Az eltiltás előzményként megmarad, többé nem számít és nem módosítható. Akkor használd, ha a döntést megsemmisítették vagy tévedésből rögzítették.',
  'suspension.revoke.reason': 'Indoklás',
  'suspension.revoke.submit': 'Megerősítés',
  'suspension.revoke.done': 'Az eltiltás visszavonva.',
  'suspension.cancel': 'Mégse',
  'error.suspension.wrongState':
    'Ez az eltiltás már letöltött vagy visszavont, ezért így nem módosítható.',
  'error.suspension.invalidInterval': 'Az utolsó nap nem lehet az első nap előtt.',
  'error.suspension.wrongMeasure':
    'A napokban számolt eltiltáshoz nem adható mérkőzésszám, és fordítva sem.',
  'match.title': 'Mérkőzések',
  'match.hint':
    'Rendelj a versenyhez egy, az osztályhoz tartozó mérkőzés-eseményt a klub csapatával, egy szakasszal és az ellenféllel. A lezárás rögzíti az érvényes szabályverziót; a lezárt vagy lemondott mérkőzés előzményként megmarad.',
  'match.loading': 'Mérkőzések betöltése…',
  'match.empty': 'Ehhez a versenyhez nincs rögzített mérkőzés.',
  'match.status.scheduled': 'Ütemezett',
  'match.status.completed': 'Lezárt',
  'match.status.cancelled': 'Lemondott',
  'match.homeAway.home': 'Hazai',
  'match.homeAway.away': 'Vendég',
  'match.eventCancelled': 'A mérkőzés naptári eseményét lemondták; a mérkőzés nem zárható le.',
  'match.ruleVersion': 'Használt szabályverzió',
  'match.noRuleVersion': 'A lezáráskor nem volt érvényben szabályverzió.',
  'match.cancelReason': 'Indok',
  'match.create.title': 'Mérkőzés rögzítése',
  'match.field.event': 'Mérkőzés-esemény',
  'match.field.team': 'Csapat',
  'match.field.phase': 'Szakasz',
  'match.field.opponent': 'Ellenfél',
  'match.field.opponentHint': 'Egy klub neve, legfeljebb 100 karakter.',
  'match.field.homeAway': 'Hazai vagy vendég',
  'match.noEvents':
    'Ebben a szezonban nincs szabad mérkőzés-esemény. Előbb hozz létre egy mérkőzés-eseményt a Naptárban.',
  'match.noTeams': 'Ennek az osztálynak és szezonnak nincs aktív csapata.',
  'match.submit': 'Mérkőzés rögzítése',
  'match.done': 'Mérkőzés rögzítve.',
  'match.correct': 'Javítás',
  'match.correct.submit': 'Javítás mentése',
  'match.correct.done': 'Mérkőzés javítva.',
  'match.complete': 'Lezárás',
  'match.complete.hint':
    'Erősítsd meg, hogy a mérkőzést lejátszották. A most érvényes szabályverzió a mérkőzéshez kerül rögzítésre, és a mérkőzés többé nem változhat.',
  'match.complete.submit': 'Lezárás',
  'match.complete.done': 'A mérkőzés lezárva.',
  'match.cancel': 'Mérkőzés lemondása',
  'match.cancel.hint':
    'A mérkőzés előzményként megmarad, és többé nem változhat. Az eseménye felszabadul egy másik mérkőzés számára.',
  'match.cancel.reason': 'Indok',
  'match.cancel.submit': 'Megerősítés',
  'match.cancel.done': 'Mérkőzés lemondva.',
  'match.close': 'Bezár',
  'error.match.wrongState':
    'Ezt a mérkőzést már lezárták vagy lemondták, ezért így nem módosítható.',
  'error.match.eventTaken': 'Ezt az eseményt már egy másik mérkőzés használja.',
  'error.match.invalidEvent': 'Válassz az osztály egy le nem mondott mérkőzés-eseményét.',
  'error.match.invalidTeam':
    'A csapatnak a verseny osztályának és szezonjának aktív csapatának kell lennie.',
  'error.match.invalidPhase': 'A szakasznak a verseny szakaszainak egyikének kell lennie.',
  'error.match.notPlayedYet':
    'A mérkőzés napja még nem érkezett el, ezért nem jelölhető lezártnak.',
  'error.match.eventCancelled':
    'A mérkőzés naptári eseményét lemondták, ezért a mérkőzés nem zárható le.',
  'roster.open': 'Keret',
  'roster.title': 'Keret',
  'roster.hint':
    'A mérkőzésre kijelölt sportolók. A kijelölés nem ellenőrzi a szabályosságot (erre szolgál lent a Szabályosság ellenőrzése), és nem bizonyítja, hogy a sportoló játszott.',
  'roster.loading': 'A keret betöltése…',
  'roster.empty': 'Erre a mérkőzésre még nincs kijelölt sportoló.',
  'roster.locked': 'Ez a mérkőzés már nem ütemezett, ezért a kerete nem módosítható.',
  'roster.role.goalkeeper': 'Kapus',
  'roster.role.defender': 'Védő',
  'roster.role.forward': 'Csatár',
  'roster.noShirt': 'nincs mezszám',
  'roster.shirt': 'Mez',
  'roster.field.athlete': 'Sportoló',
  'roster.field.role': 'Poszt ezen a mérkőzésen',
  'roster.field.shirt': 'Mezszám (0–99)',
  'roster.noAthletes': 'Nincs találat.',
  'roster.add': 'Hozzáadás a kerethez',
  'roster.add.done': 'A sportoló bekerült a keretbe.',
  'roster.edit': 'Módosítás',
  'roster.edit.submit': 'Mentés',
  'roster.edit.done': 'A kerettétel mentve.',
  'roster.remove': 'Eltávolítás',
  'roster.remove.done': 'A sportoló kikerült a keretből.',
  'roster.close': 'Bezár',
  'roster.status.draft': 'Tervezet',
  'roster.status.finalized': 'Véglegesítve',
  'roster.finalizedAt': 'Véglegesítve: {finalizedAt}.',
  'roster.acknowledged':
    'A véglegesítéskor a még felülvizsgálatra váró tételeket tudomásul vették.',
  'roster.frozen':
    'Ez a keret véglegesítve van. Nyisd újra, ha módosítani szeretnéd, vagy újra ellenőrizni a szabályosságot.',
  'roster.finalize': 'Keret véglegesítése',
  'roster.finalize.hint':
    'Előbb minden sportolót újra ellenőriz. A véglegesítés elutasításra kerül, ha egy sportoló nem szabályos, vagy a keret szabályt sért.',
  'roster.finalize.acknowledgement': 'Nyilatkozat arról, ami még felülvizsgálatra vár',
  'roster.finalize.acknowledgement.help':
    'Akkor kell, ha a kerettel kapcsolatban még bármi felülvizsgálatra vár. Írd le, hogy átnézted, és hogyan.',
  'roster.finalize.submit': 'Véglegesítés',
  'roster.finalize.done': 'A keret véglegesítve.',
  'roster.reopen': 'Keret újranyitása',
  'roster.reopen.reason': 'Az újranyitás oka',
  'roster.reopen.submit': 'Újranyitás',
  'roster.reopen.done': 'A keret újra tervezet.',
  'manualCheck.hint':
    'Csak akkor rögzíts egy ellenőrzést elvégzettként, ha magad elvégezted; a rögzítés csak erre a keretre és erre a szabályverzióra érvényes.',
  'manualCheck.open': 'nyitott',
  'manualCheck.done': 'elvégezve, ellenőrizve: {checkedOn}',
  'manualCheck.record': 'Rögzítés elvégzettként',
  'manualCheck.record.submit': 'Rögzítés',
  'manualCheck.statement': 'Mit ellenőriztél',
  'manualCheck.statement.hint': 'Ne írj egészségügyi vagy más személyes adatot.',
  'manualCheck.checkedOn': 'Az ellenőrzés napja',
  'manualCheck.withdraw': 'Rögzítés visszavonása',
  'manualCheck.withdraw.reason': 'A visszavonás oka',
  'manualCheck.withdraw.submit': 'Visszavonás',
  'manualCheck.close': 'Mégse',
  'error.manualCheck.alreadyRecorded':
    'Ez az ellenőrzés már rögzítve van erre a keretre és szabályverzióra.',
  'error.manualCheck.notRecorded': 'Ez az ellenőrzés nincs rögzítve, így nincs mit visszavonni.',
  'error.manualCheck.noActiveRules':
    'A versenysorozatnak nincs aktív szabályverziója, ezért nem rögzíthető ellenőrzés.',
  'error.manualCheck.futureDay': 'Az ellenőrzés napja nem lehet jövőbeli.',
  'externalHistory.title': 'Máshol játszott mérkőzések',
  'externalHistory.hint':
    'A sportoló azon igazolt mérkőzései, amelyek nem szerepelnek a klub keretlistáin, beleszámítanak a napi és heti korlátokba. Rögzítsd az egyes mérkőzéseket, majd igazold, hogy az előzmények teljesek; igazolás nélkül a sportoló „Felülvizsgálatot igényel” állapotban marad, ahol a szabályok korlátozzák a mérkőzések számát.',
  'externalHistory.field.athlete': 'Sportoló (írj be egy nevet)',
  'externalHistory.noAthletes': 'Nincs ilyen sportoló',
  'externalHistory.loading': 'Betöltés…',
  'externalHistory.appearances.title': 'Máshol játszott mérkőzések',
  'externalHistory.appearances.empty':
    'Ehhez a sportolóhoz nincs máshol játszott mérkőzés rögzítve.',
  'externalHistory.appearance.status.recorded': 'Rögzítve',
  'externalHistory.appearance.status.withdrawn': 'Visszavonva',
  'externalHistory.appearance.source': 'Igazolás helye',
  'externalHistory.appearance.create.title': 'Máshol játszott mérkőzés rögzítése',
  'externalHistory.appearance.field.playedOn': 'A játék napja',
  'externalHistory.appearance.field.competition': 'Bajnokság vagy klub',
  'externalHistory.appearance.field.source': 'Hol igazolták',
  'externalHistory.appearance.field.sourceHint':
    'Például jegyzőkönyv száma vagy szövetségi oldal. Ne írj személyes adatot.',
  'externalHistory.appearance.submit': 'Mérkőzés rögzítése',
  'externalHistory.appearance.done': 'A mérkőzés rögzítve. Beleszámít a napi és heti korlátokba.',
  'externalHistory.attestations.title': 'Teljességi igazolások',
  'externalHistory.attestations.empty': 'Ehhez a sportolóhoz nincs igazolás rögzítve.',
  'externalHistory.attestation.status.granted': 'Érvényes',
  'externalHistory.attestation.status.withdrawn': 'Visszavonva',
  'externalHistory.attestation.covers': 'Teljes: {from} – {through}',
  'externalHistory.attestation.create.title': 'Az előzmények teljességének igazolása',
  'externalHistory.attestation.hint':
    'Kijelented, hogy a sportoló minden igazolt, a klubon kívül játszott mérkőzése ezekben a napokban fent rögzítve van. Egy mérkőzésnél csak akkor számít, ha visszanyúlik a szabályok leghosszabb korlátozási időszakáig, és eléri a mérkőzés előtti napot.',
  'externalHistory.attestation.field.from': 'Teljes ettől',
  'externalHistory.attestation.field.through': 'Teljes eddig (nem lehet jövőbeli)',
  'externalHistory.attestation.field.statement': 'Mit ellenőriztél',
  'externalHistory.attestation.submit': 'Teljesség igazolása',
  'externalHistory.attestation.done': 'Az igazolás rögzítve.',
  'externalHistory.withdraw': 'Visszavonás',
  'externalHistory.withdraw.reason': 'A visszavonás oka',
  'externalHistory.withdraw.submit': 'Visszavonás megerősítése',
  'externalHistory.withdraw.done': 'A rögzítés visszavonva.',
  'externalHistory.withdrawnReason': 'A visszavonás oka',
  'externalHistory.cancel': 'Mégse',
  'error.externalHistory.futureDay': 'A nap nem lehet jövőbeli.',
  'error.externalHistory.wrongState': 'Ezt a rögzítést már visszavonták, és nem módosítható.',
  'roster.export': 'Keret exportálása (CSV)',
  'roster.export.hint':
    'Belső használatra letölti ezt a keretet. Belső segédlet, és soha nem szövetségi benyújtás.',
  'roster.export.ready':
    'Hivatalosan kész: minden ellenőrzés sikeres. A fájl ettől még belső segédlet, nem benyújtás.',
  'roster.export.blocked': 'Nem hivatalosan kész, ezért a fájl tervezet. Okok:',
  'roster.export.hidden': 'A hatókörödön kívüli további {count} sportoló nincs a fájlban.',
  'roster.export.blocker.PROFILE_NOT_ACTIVE': 'A versenynek nincs aktív szabályverziója.',
  'roster.export.blocker.ROSTER_NOT_FINALIZED': 'A keret nincs véglegesítve.',
  'roster.export.blocker.ENTRIES_NOT_VISIBLE':
    'A kereten olyan sportolók is vannak, akik a hatókörödön kívül esnek, ezért a fájl nem sorolhatja fel teljes egészében.',
  'roster.export.blocker.ROSTER_NOT_ELIGIBLE':
    'Egy sportoló vagy a keret egésze nem szerepeltethető, vagy még felülvizsgálatra szorul.',
  'roster.export.blocker.MANUAL_CHECK_UNRESOLVED':
    'A(z) „{key}” kézi ellenőrzés nincs elvégzettként rögzítve.',
  'roster.export.file.label': 'Belső segédlet, nem hivatalos benyújtás',
  'roster.export.file.competition': 'Verseny',
  'roster.export.file.opponent': 'Ellenfél',
  'roster.export.file.matchDay': 'Mérkőzés napja',
  'roster.export.file.status': 'A keret állapota',
  'roster.export.file.officialReady': 'Hivatalosan kész',
  'roster.export.file.yes': 'igen',
  'roster.export.file.no': 'nem',
  'roster.export.file.blocker': 'Miért nem hivatalosan kész',
  'roster.export.column.shirt': 'Mezszám',
  'roster.export.column.familyName': 'Vezetéknév',
  'roster.export.column.givenName': 'Keresztnév',
  'roster.export.column.role': 'Szerep',
  'roster.export.column.outcome': 'Szerepeltethetőség',
  'eligibility.title': 'Szabályosság',
  'eligibility.hint':
    'A keret minden sportolóját és a keretet egészében a verseny aktív szabályverziója szerint ellenőrzi, és elmenti az eredményt. Csak az automatizált szabályokra terjed ki; a lent felsorolt kézi ellenőrzések nálad maradnak.',
  'eligibility.loading': 'A szabályossági ellenőrzés betöltése…',
  'eligibility.none': 'Ezt a keretet még nem ellenőrizték.',
  'eligibility.evaluate': 'Szabályosság ellenőrzése',
  'eligibility.evaluate.again': 'Újraellenőrzés',
  'eligibility.evaluate.done': 'A szabályosság ellenőrizve és elmentve.',
  'eligibility.checked':
    'Ellenőrizve: {checkedAt}, a(z) {matchDay} mérkőzésnapra, a(z) {version}. szabályverzióval.',
  'eligibility.checkedWithoutRules':
    'Ellenőrizve: {checkedAt}, a(z) {matchDay} mérkőzésnapra, aktív szabályverzió nélkül.',
  'eligibility.roster': 'A keret egészében:',
  'eligibility.outcome.ELIGIBLE': 'Szabályos',
  'eligibility.outcome.INELIGIBLE': 'Nem szabályos',
  'eligibility.outcome.REVIEW_REQUIRED': 'Felülvizsgálatot igényel',
  'eligibility.stale': 'Az ellenőrzés óta valami megváltozott. Ellenőrizd újra.',
  'eligibility.decisionStale': 'elavult',
  'eligibility.removed': 'már nincs a keretben',
  'eligibility.rosterChanged': 'A keret az ellenőrzés óta megváltozott. Ellenőrizd újra.',
  'eligibility.rulesChanged': 'Most egy másik szabályverzió aktív. Ellenőrizd újra.',
  'eligibility.hidden':
    'További {count} sportolót is ellenőrzött a rendszer, akik kívül esnek a hatókörödön.',
  'eligibility.manualChecks': 'Nálad maradó kézi ellenőrzések:',
  'eligibility.source': 'forrás',
  'eligibility.exception': 'kivétellel rendezve: {reference}',
  'eligibility.reason.unknown': 'Ok: {code}.',
  'eligibility.reason.PROFILE_MISSING':
    'A versenynek nincs aktív szabályverziója, ezért felülvizsgálat szükséges.',
  'eligibility.reason.PROFILE_NOT_ACTIVE':
    'A szabályverzió állapota: {status}, nem aktív, ezért felülvizsgálat szükséges.',
  'eligibility.reason.PROFILE_NOT_VALID_ON_DATE':
    'Az aktív szabályverzió nem terjed ki a mérkőzés napjára.',
  'eligibility.reason.BIRTH_DATE_AFTER_MATCH': 'A születési dátum a mérkőzés napja utáni.',
  'eligibility.reason.REGISTRATION_MISSING': 'A sportoló nincs regisztrálva ebben a versenyben.',
  'eligibility.reason.REGISTRATION_NOT_VALID':
    'A versenybeli regisztráció lezárult, vagy nem terjed ki a mérkőzés napjára.',
  'eligibility.reason.LICENSE_REFERENCE_MISSING': 'A regisztrációhoz nincs licenchivatkozás.',
  'eligibility.reason.CLASSIFICATION_NOT_PERMITTED':
    'A(z) „{classification}” besorolás nem megengedett ebben a versenyben.',
  'eligibility.reason.AGE_BELOW_MINIMUM':
    'A mérkőzés napján betöltött {age} év kevesebb a minimális {minimumAge} évnél.',
  'eligibility.reason.EXCLUSIVE_HIGHER_REGISTRATION':
    'A sportoló kizárólag a magasabb, {higherCategory} korosztályra van regisztrálva.',
  'eligibility.reason.BIRTH_DATE_ROUTE_NOT_DEFINED':
    'A szabályok nem határoznak meg születési időszakot ehhez a regisztrációhoz, ezért felülvizsgálat szükséges.',
  'eligibility.reason.AGE_EXCEPTION_NOT_SUPPORTED':
    'A verseny szabályai nem engedik a(z) „{registrationMode}” regisztrációs módot.',
  'eligibility.reason.BIRTH_DATE_OUTSIDE_PERMITTED_RANGE':
    'A születési dátum kívül esik a(z) „{registrationMode}” regisztrációs módhoz megengedett időszakon.',
  'eligibility.reason.DOCUMENT_MISSING': 'Nincs rögzítve: {documentType}.',
  'eligibility.reason.DOCUMENT_NOT_VERIFIED': 'Nincs igazolva: {documentType}.',
  'eligibility.reason.DOCUMENT_EXPIRED': 'A mérkőzés napja előtt lejárt: {documentType}.',
  'eligibility.reason.DOCUMENT_NOT_YET_VALID':
    'A mérkőzés napján még nem érvényes: {documentType}.',
  'eligibility.reason.SUSPENDED': 'Aktív eltiltás vonatkozik erre a mérkőzésre.',
  'eligibility.reason.ATTESTATION_MISSING': 'Egy szükséges jóváhagyás nincs rögzítve.',
  'eligibility.reason.ATTESTATION_DENIED': 'Egy szükséges jóváhagyást elutasítottak.',
  'eligibility.reason.TEAM_CHANGE_OUTSIDE_WINDOW':
    'Ebben a szakaszban nem megengedett az átjátszás a klub csapatai között.',
  'eligibility.reason.EXTERNAL_HISTORY_INCOMPLETE':
    'A klubon kívül játszott mérkőzések nincsenek rögzítve, ezért a mérkőzéskorlátok felülvizsgálatot igényelnek.',
  'eligibility.reason.DAILY_LIMIT_EXCEEDED':
    '{count} mérkőzés a mérkőzés napján; a(z) {profileCategory} szabályai {maximum} mérkőzést engednek.',
  'eligibility.reason.ROLLING_WINDOW_LIMIT_EXCEEDED':
    '{count} mérkőzés {windowDays} napon belül; a(z) {profileCategory} szabályai {maximum} mérkőzést engednek.',
  'eligibility.reason.PLAYOFF_PARTICIPATION_UNCONFIRMED':
    'A rájátszásbeli részvétel csak akkor számít, ha egy klubadminisztrátor megerősítette, mi számít bele.',
  'eligibility.reason.PLAYOFF_PARTICIPATION_UNKNOWN': 'A rájátszásbeli részvétel nincs rögzítve.',
  'eligibility.reason.PLAYOFF_PARTICIPATION_BELOW_MINIMUM':
    '{matches} mérkőzésből {appearances} részvétel kevesebb, mint {minimumPercent}%.',
  'eligibility.reason.ROSTER_RULES_NOT_DEFINED':
    'A szabályok nem határoznak meg keretlétszámot ehhez a csapathoz.',
  'eligibility.reason.ROSTER_SKATERS_MINIMUM_DEPENDS_ON_REVIEW':
    'A legalább {minimum} mezőnyjátékos csak akkor van meg, ha a felülvizsgálatra váró sportolókat megerősítik.',
  'eligibility.reason.ROSTER_SKATERS_MINIMUM_NEEDS_PROMOTED_COUNT_REVIEW':
    'A legalább {minimum} mezőnyjátékos csak a feljátszó sportolókkal együtt van meg.',
  'eligibility.reason.ROSTER_SKATERS_BELOW_MINIMUM':
    '{counted} szabályos mezőnyjátékos; legalább {minimum} kell.',
  'eligibility.reason.ROSTER_SKATERS_ABOVE_MAXIMUM':
    '{counted} mezőnyjátékos; legfeljebb {maximum} megengedett.',
  'eligibility.reason.ROSTER_GOALKEEPERS_MINIMUM_DEPENDS_ON_REVIEW':
    'A legalább {minimum} kapus csak akkor van meg, ha a felülvizsgálatra váró sportolókat megerősítik.',
  'eligibility.reason.ROSTER_GOALKEEPERS_MINIMUM_NEEDS_PROMOTED_COUNT_REVIEW':
    'A legalább {minimum} kapus csak a feljátszó sportolókkal együtt van meg.',
  'eligibility.reason.ROSTER_GOALKEEPERS_BELOW_MINIMUM':
    '{counted} szabályos kapus; legalább {minimum} kell.',
  'eligibility.reason.ROSTER_GOALKEEPERS_ABOVE_MAXIMUM':
    '{counted} kapus; legfeljebb {maximum} megengedett.',
  'eligibility.reason.ROSTER_PROMOTION_QUOTA_EXCEEDED':
    '{counted} ideiglenesen feljátszó sportoló; legfeljebb {maximum} megengedett.',
  'eligibility.reason.ROSTER_HAS_INELIGIBLE_ENTRIES': '{count} sportoló nem szabályos.',
  'eligibility.reason.ROSTER_HAS_ENTRIES_UNDER_REVIEW':
    '{count} sportoló felülvizsgálatot igényel.',
  'error.roster.athleteNotActive': 'Csak aktív sportoló jelölhető ki a keretbe.',
  'error.roster.shirtNumberTaken': 'A keret egy másik sportolója már ezt a mezszámot viseli.',
  'error.roster.finalized': 'Ez a keret véglegesítve van. Nyisd újra, ha módosítani szeretnéd.',
  'error.roster.empty': 'A véglegesítés előtt jelölj ki legalább egy sportolót.',
  'error.roster.notFinalizable':
    'A keret nem véglegesíthető: egy sportoló nem szabályos, vagy a keret szabályt sért. A szabályosság ellenőrzésénél láthatod az okot.',
  'error.roster.acknowledgementRequired':
    'A kerettel kapcsolatban még valami felülvizsgálatra vár. Szavakkal jelentsd ki, hogy átnézted, majd véglegesítsd.',
  'error.roster.notFinalized': 'Ez a keret nincs véglegesítve.',
} as const satisfies Record<TranslationKey, string>;
